// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Sora, ui-sans-serif, system-ui, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-\\[3px\\] {
  inset: 3px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-12 {
  bottom: -3rem;
}
.-bottom-28 {
  bottom: -7rem;
}
.-left-12 {
  left: -3rem;
}
.-left-20 {
  left: -5rem;
}
.-left-\\[24px\\] {
  left: -24px;
}
.-right-1 {
  right: -0.25rem;
}
.-right-1\\.5 {
  right: -0.375rem;
}
.-right-12 {
  right: -3rem;
}
.-right-16 {
  right: -4rem;
}
.-right-2 {
  right: -0.5rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-1\\.5 {
  top: -0.375rem;
}
.-top-12 {
  top: -3rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-24 {
  top: -6rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.left-0 {
  left: 0px;
}
.left-0\\.5 {
  left: 0.125rem;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-3 {
  left: 0.75rem;
}
.left-5 {
  left: 1.25rem;
}
.left-\\[18px\\] {
  left: 18px;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-8 {
  right: 2rem;
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-24 {
  top: 6rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-\\[18\\%\\] {
  top: 18%;
}
.top-\\[1px\\] {
  top: 1px;
}
.top-\\[4\\.25rem\\] {
  top: 4.25rem;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[60\\%\\] {
  top: 60%;
}
.top-full {
  top: 100%;
}
.isolate {
  isolation: isolate;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[200\\] {
  z-index: 200;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[70\\] {
  z-index: 70;
}
.z-\\[80\\] {
  z-index: 80;
}
.z-\\[90\\] {
  z-index: 90;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.-mx-5 {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.-ml-4 {
  margin-left: -1rem;
}
.-mt-1 {
  margin-top: -0.25rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.-mt-4 {
  margin-top: -1rem;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-12 {
  margin-left: 3rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-\\[22px\\] {
  margin-left: 22px;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-12 {
  margin-right: 3rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-24 {
  margin-top: 6rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.inline-grid {
  display: inline-grid;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.aspect-\\[16\\/10\\] {
  aspect-ratio: 16/10;
}
.aspect-\\[16\\/9\\] {
  aspect-ratio: 16/9;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-44 {
  height: 11rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-80 {
  height: 20rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[160px\\] {
  height: 160px;
}
.h-\\[180px\\] {
  height: 180px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[260px\\] {
  height: 260px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[42px\\] {
  height: 42px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[520px\\] {
  height: 520px;
}
.h-\\[52px\\] {
  height: 52px;
}
.h-\\[640px\\] {
  height: 640px;
}
.h-\\[64px\\] {
  height: 64px;
}
.h-\\[88px\\] {
  height: 88px;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\] {
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\] {
  height: var(--radix-select-trigger-height);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\] {
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\] {
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[160px\\] {
  max-height: 160px;
}
.max-h-\\[180px\\] {
  max-height: 180px;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[260px\\] {
  max-height: 260px;
}
.max-h-\\[280px\\] {
  max-height: 280px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[420px\\] {
  max-height: 420px;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[84vh\\] {
  max-height: 84vh;
}
.max-h-\\[88vh\\] {
  max-height: 88vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[92vh\\] {
  max-height: 92vh;
}
.max-h-\\[calc\\(100vh-20rem\\)\\] {
  max-height: calc(100vh - 20rem);
}
.max-h-\\[min\\(78vh\\2c 36rem\\)\\] {
  max-height: min(78vh, 36rem);
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\] {
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-screen {
  max-height: 100vh;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[260px\\] {
  min-height: 260px;
}
.min-h-\\[3\\.25rem\\] {
  min-height: 3.25rem;
}
.min-h-\\[34px\\] {
  min-height: 34px;
}
.min-h-\\[4\\.125rem\\] {
  min-height: 4.125rem;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-\\[70px\\] {
  min-height: 70px;
}
.min-h-\\[72px\\] {
  min-height: 72px;
}
.min-h-\\[90px\\] {
  min-height: 90px;
}
.min-h-\\[min\\(70vh\\2c 640px\\)\\] {
  min-height: min(70vh, 640px);
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-40 {
  width: 10rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[280px\\] {
  width: 280px;
}
.w-\\[32px\\] {
  width: 32px;
}
.w-\\[64px\\] {
  width: 64px;
}
.w-\\[72px\\] {
  width: 72px;
}
.w-\\[88px\\] {
  width: 88px;
}
.w-\\[min\\(20rem\\2c 88vw\\)\\] {
  width: min(20rem, 88vw);
}
.w-\\[min\\(34vw\\2c 340px\\)\\] {
  width: min(34vw, 340px);
}
.w-\\[min\\(520px\\2c 55vw\\)\\] {
  width: min(520px, 55vw);
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-10 {
  min-width: 2.5rem;
}
.min-w-4 {
  min-width: 1rem;
}
.min-w-8 {
  min-width: 2rem;
}
.min-w-9 {
  min-width: 2.25rem;
}
.min-w-\\[12rem\\] {
  min-width: 12rem;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[52px\\] {
  min-width: 52px;
}
.min-w-\\[560px\\] {
  min-width: 560px;
}
.min-w-\\[600px\\] {
  min-width: 600px;
}
.min-w-\\[640px\\] {
  min-width: 640px;
}
.min-w-\\[700px\\] {
  min-width: 700px;
}
.min-w-\\[720px\\] {
  min-width: 720px;
}
.min-w-\\[72px\\] {
  min-width: 72px;
}
.min-w-\\[760px\\] {
  min-width: 760px;
}
.min-w-\\[820px\\] {
  min-width: 820px;
}
.min-w-\\[860px\\] {
  min-width: 860px;
}
.min-w-\\[8rem\\] {
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
  min-width: var(--radix-select-trigger-width);
}
.min-w-full {
  min-width: 100%;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[1100px\\] {
  max-width: 1100px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[160px\\] {
  max-width: 160px;
}
.max-w-\\[16rem\\] {
  max-width: 16rem;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[260px\\] {
  max-width: 260px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[420px\\] {
  max-width: 420px;
}
.max-w-\\[440px\\] {
  max-width: 440px;
}
.max-w-\\[480px\\] {
  max-width: 480px;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[520px\\] {
  max-width: 520px;
}
.max-w-\\[55\\%\\] {
  max-width: 55%;
}
.max-w-\\[560px\\] {
  max-width: 560px;
}
.max-w-\\[580px\\] {
  max-width: 580px;
}
.max-w-\\[640px\\] {
  max-width: 640px;
}
.max-w-\\[680px\\] {
  max-width: 680px;
}
.max-w-\\[720px\\] {
  max-width: 720px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[800px\\] {
  max-width: 800px;
}
.max-w-\\[820px\\] {
  max-width: 820px;
}
.max-w-\\[85\\%\\] {
  max-width: 85%;
}
.max-w-\\[900px\\] {
  max-width: 900px;
}
.max-w-\\[92vw\\] {
  max-width: 92vw;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-max {
  max-width: max-content;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.grow-0 {
  flex-grow: 0;
}
.basis-full {
  flex-basis: 100%;
}
.caption-bottom {
  caption-side: bottom;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\] {
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\] {
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\] {
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\] {
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\] {
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\] {
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\] {
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5 {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[32px\\] {
  --tw-translate-x: 32px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-\\[-1\\] {
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-zoom-in {
  cursor: zoom-in;
}
.touch-none {
  touch-action: none;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.scroll-mt-24 {
  scroll-margin-top: 6rem;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[1\\.2fr_80px_1fr_1fr_1fr_110px\\] {
  grid-template-columns: 1.2fr 80px 1fr 1fr 1fr 110px;
}
.grid-cols-\\[1\\.4fr_1fr_0\\.8fr_1fr\\] {
  grid-template-columns: 1.4fr 1fr 0.8fr 1fr;
}
.grid-cols-\\[1\\.4fr_1fr_1fr_110px_1fr\\] {
  grid-template-columns: 1.4fr 1fr 1fr 110px 1fr;
}
.grid-cols-\\[1\\.4fr_1fr_1fr_130px\\] {
  grid-template-columns: 1.4fr 1fr 1fr 130px;
}
.grid-cols-\\[1\\.4fr_1fr_1fr_1fr\\] {
  grid-template-columns: 1.4fr 1fr 1fr 1fr;
}
.grid-cols-\\[1\\.5fr_1fr_1\\.2fr_1fr_1fr_110px\\] {
  grid-template-columns: 1.5fr 1fr 1.2fr 1fr 1fr 110px;
}
.grid-cols-\\[1\\.6fr_90px_1fr_130px\\] {
  grid-template-columns: 1.6fr 90px 1fr 130px;
}
.grid-cols-\\[100px_1\\.6fr_100px_110px_120px_80px\\] {
  grid-template-columns: 100px 1.6fr 100px 110px 120px 80px;
}
.grid-cols-\\[110px\\2c 1fr\\] {
  grid-template-columns: 110px 1fr;
}
.grid-cols-\\[1fr_0\\.8fr_1fr_0\\.8fr_1fr\\] {
  grid-template-columns: 1fr 0.8fr 1fr 0.8fr 1fr;
}
.grid-cols-\\[1fr_1fr_1\\.2fr_1\\.2fr_1fr_90px_120px\\] {
  grid-template-columns: 1fr 1fr 1.2fr 1.2fr 1fr 90px 120px;
}
.grid-cols-\\[1fr_1fr_1\\.2fr_1fr_1\\.4fr_110px_80px\\] {
  grid-template-columns: 1fr 1fr 1.2fr 1fr 1.4fr 110px 80px;
}
.grid-cols-\\[1fr_1fr_1fr_1fr_100px_90px\\] {
  grid-template-columns: 1fr 1fr 1fr 1fr 100px 90px;
}
.grid-cols-\\[1fr_auto\\] {
  grid-template-columns: 1fr auto;
}
.grid-cols-\\[28px_1\\.4fr_1fr_100px_1fr_1fr\\] {
  grid-template-columns: 28px 1.4fr 1fr 100px 1fr 1fr;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-border > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: oklch(var(--border) / var(--tw-divide-opacity, 1));
}
.divide-border\\/70 > :not([hidden]) ~ :not([hidden]) {
  border-color: oklch(var(--border) / 0.7);
}
.divide-line > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: oklch(var(--border) / var(--tw-divide-opacity, 1));
}
.justify-self-end {
  justify-self: end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-x-clip {
  overflow-x: clip;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[inherit\\] {
  border-radius: inherit;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: var(--radius);
}
.rounded-md {
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm {
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-\\[10px\\] {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-tl-sm {
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-amber-500\\/30 {
  border-color: rgb(245 158 11 / 0.3);
}
.border-amber-500\\/40 {
  border-color: rgb(245 158 11 / 0.4);
}
.border-amber-700 {
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / var(--tw-border-opacity, 1));
}
.border-amber-700\\/50 {
  border-color: rgb(180 83 9 / 0.5);
}
.border-blue-700\\/50 {
  border-color: rgb(29 78 216 / 0.5);
}
.border-border {
  --tw-border-opacity: 1;
  border-color: oklch(var(--border) / var(--tw-border-opacity, 1));
}
.border-border\\/60 {
  border-color: oklch(var(--border) / 0.6);
}
.border-border\\/70 {
  border-color: oklch(var(--border) / 0.7);
}
.border-border\\/80 {
  border-color: oklch(var(--border) / 0.8);
}
.border-cm-navy {
  --tw-border-opacity: 1;
  border-color: oklch(var(--foreground) / var(--tw-border-opacity, 1));
}
.border-destructive {
  --tw-border-opacity: 1;
  border-color: oklch(var(--down) / var(--tw-border-opacity, 1));
}
.border-destructive\\/50 {
  border-color: oklch(var(--down) / 0.5);
}
.border-down {
  --tw-border-opacity: 1;
  border-color: oklch(var(--down) / var(--tw-border-opacity, 1));
}
.border-down\\/20 {
  border-color: oklch(var(--down) / 0.2);
}
.border-down\\/25 {
  border-color: oklch(var(--down) / 0.25);
}
.border-down\\/30 {
  border-color: oklch(var(--down) / 0.3);
}
.border-down\\/40 {
  border-color: oklch(var(--down) / 0.4);
}
.border-down\\/60 {
  border-color: oklch(var(--down) / 0.6);
}
.border-emerald-500\\/20 {
  border-color: rgb(16 185 129 / 0.2);
}
.border-emerald-500\\/25 {
  border-color: rgb(16 185 129 / 0.25);
}
.border-emerald-500\\/30 {
  border-color: rgb(16 185 129 / 0.3);
}
.border-emerald-500\\/40 {
  border-color: rgb(16 185 129 / 0.4);
}
.border-green-800 {
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity, 1));
}
.border-input {
  --tw-border-opacity: 1;
  border-color: oklch(var(--input) / var(--tw-border-opacity, 1));
}
.border-line {
  --tw-border-opacity: 1;
  border-color: oklch(var(--border) / var(--tw-border-opacity, 1));
}
.border-line\\/50 {
  border-color: oklch(var(--border) / 0.5);
}
.border-line\\/60 {
  border-color: oklch(var(--border) / 0.6);
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: oklch(var(--primary) / var(--tw-border-opacity, 1));
}
.border-primary\\/20 {
  border-color: oklch(var(--primary) / 0.2);
}
.border-primary\\/25 {
  border-color: oklch(var(--primary) / 0.25);
}
.border-primary\\/30 {
  border-color: oklch(var(--primary) / 0.3);
}
.border-primary\\/40 {
  border-color: oklch(var(--primary) / 0.4);
}
.border-primary\\/50 {
  border-color: oklch(var(--primary) / 0.5);
}
.border-primary\\/\\[0\\.55\\] {
  border-color: oklch(var(--primary) / 0.55);
}
.border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-500\\/25 {
  border-color: rgb(239 68 68 / 0.25);
}
.border-red-500\\/30 {
  border-color: rgb(239 68 68 / 0.3);
}
.border-red-500\\/40 {
  border-color: rgb(239 68 68 / 0.4);
}
.border-red-500\\/60 {
  border-color: rgb(239 68 68 / 0.6);
}
.border-red-700 {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity, 1));
}
.border-red-700\\/50 {
  border-color: rgb(185 28 28 / 0.5);
}
.border-sky-500\\/30 {
  border-color: rgb(14 165 233 / 0.3);
}
.border-transparent {
  border-color: transparent;
}
.border-up\\/30 {
  border-color: oklch(var(--up) / 0.3);
}
.border-up\\/40 {
  border-color: oklch(var(--up) / 0.4);
}
.border-violet-200 {
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}
.border-violet-500\\/20 {
  border-color: rgb(139 92 246 / 0.2);
}
.border-warning\\/30 {
  border-color: oklch(var(--warning) / 0.3);
}
.border-warning\\/40 {
  border-color: oklch(var(--warning) / 0.4);
}
.border-warning\\/50 {
  border-color: oklch(var(--warning) / 0.5);
}
.border-white\\/15 {
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/25 {
  border-color: rgb(255 255 255 / 0.25);
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}
.border-yellow-500\\/60 {
  border-color: rgb(234 179 8 / 0.6);
}
.border-zinc-600\\/50 {
  border-color: rgb(82 82 91 / 0.5);
}
.border-zinc-700 {
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity, 1));
}
.border-zinc-800 {
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity, 1));
}
.border-zinc-800\\/50 {
  border-color: rgb(39 39 42 / 0.5);
}
.border-l-primary {
  --tw-border-opacity: 1;
  border-left-color: oklch(var(--primary) / var(--tw-border-opacity, 1));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-t-transparent {
  border-top-color: transparent;
}
.bg-\\[oklch\\(0\\.12_0\\.02_160\\)\\] {
  background-color: oklch(0.12 0.02 160);
}
.bg-\\[oklch\\(0\\.12_0\\.03_160_\\/_0\\.55\\)\\] {
  background-color: oklch(0.12 0.03 160 / 0.55);
}
.bg-accent {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--accent) / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/10 {
  background-color: rgb(245 158 11 / 0.1);
}
.bg-amber-500\\/15 {
  background-color: rgb(245 158 11 / 0.15);
}
.bg-amber-500\\/25 {
  background-color: rgb(245 158 11 / 0.25);
}
.bg-amber-900\\/20 {
  background-color: rgb(120 53 15 / 0.2);
}
.bg-amber-900\\/30 {
  background-color: rgb(120 53 15 / 0.3);
}
.bg-background {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--background) / var(--tw-bg-opacity, 1));
}
.bg-background\\/40 {
  background-color: oklch(var(--background) / 0.4);
}
.bg-background\\/50 {
  background-color: oklch(var(--background) / 0.5);
}
.bg-background\\/60 {
  background-color: oklch(var(--background) / 0.6);
}
.bg-background\\/70 {
  background-color: oklch(var(--background) / 0.7);
}
.bg-background\\/75 {
  background-color: oklch(var(--background) / 0.75);
}
.bg-background\\/80 {
  background-color: oklch(var(--background) / 0.8);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/0 {
  background-color: rgb(0 0 0 / 0);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45 {
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/65 {
  background-color: rgb(0 0 0 / 0.65);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/85 {
  background-color: rgb(0 0 0 / 0.85);
}
.bg-blue-500\\/15 {
  background-color: rgb(59 130 246 / 0.15);
}
.bg-blue-900\\/20 {
  background-color: rgb(30 58 138 / 0.2);
}
.bg-border {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--border) / var(--tw-bg-opacity, 1));
}
.bg-brand-emerald {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--brand-emerald) / var(--tw-bg-opacity, 1));
}
.bg-brand-ink {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--brand-ink) / var(--tw-bg-opacity, 1));
}
.bg-brand-lime {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--brand-lime) / var(--tw-bg-opacity, 1));
}
.bg-card {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--card) / var(--tw-bg-opacity, 1));
}
.bg-card\\/90 {
  background-color: oklch(var(--card) / 0.9);
}
.bg-cm-lavender {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--surface-2) / var(--tw-bg-opacity, 1));
}
.bg-cm-navy\\/50 {
  background-color: oklch(var(--foreground) / 0.5);
}
.bg-cm-navy\\/70 {
  background-color: oklch(var(--foreground) / 0.7);
}
.bg-cm-surface\\/50 {
  background-color: oklch(var(--page) / 0.5);
}
.bg-cm-surface\\/60 {
  background-color: oklch(var(--page) / 0.6);
}
.bg-cm-surface\\/70 {
  background-color: oklch(var(--page) / 0.7);
}
.bg-destructive {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--down) / var(--tw-bg-opacity, 1));
}
.bg-down {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--down) / var(--tw-bg-opacity, 1));
}
.bg-down\\/10 {
  background-color: oklch(var(--down) / 0.1);
}
.bg-down\\/15 {
  background-color: oklch(var(--down) / 0.15);
}
.bg-down\\/20 {
  background-color: oklch(var(--down) / 0.2);
}
.bg-down\\/5 {
  background-color: oklch(var(--down) / 0.05);
}
.bg-down\\/70 {
  background-color: oklch(var(--down) / 0.7);
}
.bg-down\\/90 {
  background-color: oklch(var(--down) / 0.9);
}
.bg-down\\/\\[0\\.12\\] {
  background-color: oklch(var(--down) / 0.12);
}
.bg-emerald-400\\/25 {
  background-color: rgb(52 211 153 / 0.25);
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10 {
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/15 {
  background-color: rgb(16 185 129 / 0.15);
}
.bg-emerald-500\\/25 {
  background-color: rgb(16 185 129 / 0.25);
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-900\\/20 {
  background-color: rgb(6 78 59 / 0.2);
}
.bg-emerald-900\\/30 {
  background-color: rgb(6 78 59 / 0.3);
}
.bg-emerald-900\\/40 {
  background-color: rgb(6 78 59 / 0.4);
}
.bg-foreground {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--foreground) / var(--tw-bg-opacity, 1));
}
.bg-green-900\\/20 {
  background-color: rgb(20 83 45 / 0.2);
}
.bg-line {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--border) / var(--tw-bg-opacity, 1));
}
.bg-muted {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--muted) / var(--tw-bg-opacity, 1));
}
.bg-muted-foreground {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--muted-foreground) / var(--tw-bg-opacity, 1));
}
.bg-muted\\/50 {
  background-color: oklch(var(--muted) / 0.5);
}
.bg-page\\/85 {
  background-color: oklch(var(--page) / 0.85);
}
.bg-popover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--popover) / var(--tw-bg-opacity, 1));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--primary) / var(--tw-bg-opacity, 1));
}
.bg-primary\\/10 {
  background-color: oklch(var(--primary) / 0.1);
}
.bg-primary\\/15 {
  background-color: oklch(var(--primary) / 0.15);
}
.bg-primary\\/20 {
  background-color: oklch(var(--primary) / 0.2);
}
.bg-primary\\/5 {
  background-color: oklch(var(--primary) / 0.05);
}
.bg-primary\\/\\[0\\.06\\] {
  background-color: oklch(var(--primary) / 0.06);
}
.bg-primary\\/\\[0\\.12\\] {
  background-color: oklch(var(--primary) / 0.12);
}
.bg-primary\\/\\[0\\.15\\] {
  background-color: oklch(var(--primary) / 0.15);
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10 {
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/15 {
  background-color: rgb(239 68 68 / 0.15);
}
.bg-red-500\\/25 {
  background-color: rgb(239 68 68 / 0.25);
}
.bg-red-900\\/30 {
  background-color: rgb(127 29 29 / 0.3);
}
.bg-red-900\\/40 {
  background-color: rgb(127 29 29 / 0.4);
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--secondary) / var(--tw-bg-opacity, 1));
}
.bg-sky-500\\/10 {
  background-color: rgb(14 165 233 / 0.1);
}
.bg-surface {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--surface) / var(--tw-bg-opacity, 1));
}
.bg-surface-2 {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--surface-2) / var(--tw-bg-opacity, 1));
}
.bg-surface-2\\/40 {
  background-color: oklch(var(--surface-2) / 0.4);
}
.bg-surface-2\\/50 {
  background-color: oklch(var(--surface-2) / 0.5);
}
.bg-surface-2\\/60 {
  background-color: oklch(var(--surface-2) / 0.6);
}
.bg-surface\\/30 {
  background-color: oklch(var(--surface) / 0.3);
}
.bg-surface\\/40 {
  background-color: oklch(var(--surface) / 0.4);
}
.bg-surface\\/50 {
  background-color: oklch(var(--surface) / 0.5);
}
.bg-surface\\/60 {
  background-color: oklch(var(--surface) / 0.6);
}
.bg-surface\\/70 {
  background-color: oklch(var(--surface) / 0.7);
}
.bg-surface\\/80 {
  background-color: oklch(var(--surface) / 0.8);
}
.bg-transparent {
  background-color: transparent;
}
.bg-up {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--up) / var(--tw-bg-opacity, 1));
}
.bg-up\\/10 {
  background-color: oklch(var(--up) / 0.1);
}
.bg-up\\/15 {
  background-color: oklch(var(--up) / 0.15);
}
.bg-up\\/20 {
  background-color: oklch(var(--up) / 0.2);
}
.bg-up\\/5 {
  background-color: oklch(var(--up) / 0.05);
}
.bg-up\\/60 {
  background-color: oklch(var(--up) / 0.6);
}
.bg-up\\/90 {
  background-color: oklch(var(--up) / 0.9);
}
.bg-up\\/\\[0\\.12\\] {
  background-color: oklch(var(--up) / 0.12);
}
.bg-violet-500\\/10 {
  background-color: rgb(139 92 246 / 0.1);
}
.bg-warning {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--warning) / var(--tw-bg-opacity, 1));
}
.bg-warning\\/10 {
  background-color: oklch(var(--warning) / 0.1);
}
.bg-warning\\/15 {
  background-color: oklch(var(--warning) / 0.15);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15 {
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/5 {
  background-color: rgb(255 255 255 / 0.05);
}
.bg-yellow-500\\/10 {
  background-color: rgb(234 179 8 / 0.1);
}
.bg-zinc-700\\/40 {
  background-color: rgb(63 63 70 / 0.4);
}
.bg-zinc-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[linear-gradient\\(100deg\\2c transparent\\2c rgb\\(255_255_255\\/0\\.45\\)\\2c transparent\\)\\] {
  background-image: linear-gradient(100deg,transparent,rgb(255 255 255/0.45),transparent);
}
.bg-\\[linear-gradient\\(120deg\\2c oklch\\(var\\(--brand-emerald\\)\\)\\2c oklch\\(var\\(--brand-lime\\)\\)\\)\\] {
  background-image: linear-gradient(120deg,oklch(var(--brand-emerald)),oklch(var(--brand-lime)));
}
.bg-\\[linear-gradient\\(120deg\\2c oklch\\(var\\(--primary\\)\\/0\\.14\\)\\2c transparent\\)\\] {
  background-image: linear-gradient(120deg,oklch(var(--primary)/0.14),transparent);
}
.bg-\\[linear-gradient\\(90deg\\2c oklch\\(0\\.1_0\\.025_160_\\/_0\\.94\\)_0\\%\\2c oklch\\(0\\.1_0\\.025_160_\\/_0\\.88\\)_42\\%\\2c oklch\\(0\\.1_0\\.025_160_\\/_0\\.45\\)_68\\%\\2c oklch\\(0\\.1_0\\.025_160_\\/_0\\.12\\)_100\\%\\)\\] {
  background-image: linear-gradient(90deg,oklch(0.1 0.025 160 / 0.94) 0%,oklch(0.1 0.025 160 / 0.88) 42%,oklch(0.1 0.025 160 / 0.45) 68%,oklch(0.1 0.025 160 / 0.12) 100%);
}
.bg-\\[linear-gradient\\(to_top\\2c oklch\\(0\\.1_0\\.025_160_\\/_0\\.55\\)_0\\%\\2c transparent_45\\%\\)\\] {
  background-image: linear-gradient(to top,oklch(0.1 0.025 160 / 0.55) 0%,transparent 45%);
}
.bg-\\[radial-gradient\\(ellipse_at_75\\%_55\\%\\2c oklch\\(0\\.74_0\\.18_153_\\/_0\\.28\\)\\2c transparent_55\\%\\)\\] {
  background-image: radial-gradient(ellipse at 75% 55%,oklch(0.74 0.18 153 / 0.28),transparent 55%);
}
.bg-\\[radial-gradient\\(ellipse_at_top\\2c oklch\\(var\\(--primary\\)\\/0\\.16\\)\\2c transparent_60\\%\\)\\] {
  background-image: radial-gradient(ellipse at top,oklch(var(--primary)/0.16),transparent 60%);
}
.bg-\\[radial-gradient\\(ellipse_at_top\\2c oklch\\(var\\(--primary\\)\\/0\\.18\\)\\2c transparent_58\\%\\)\\] {
  background-image: radial-gradient(ellipse at top,oklch(var(--primary)/0.18),transparent 58%);
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#0F1730\\] {
  --tw-gradient-from: #0F1730 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 48 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500 {
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cm-blue {
  --tw-gradient-from: oklch(var(--primary) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: oklch(var(--primary) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cm-navy {
  --tw-gradient-from: oklch(var(--foreground) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: oklch(var(--foreground) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500 {
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500 {
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-50 {
  --tw-gradient-from: #f5f3ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 243 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-600 {
  --tw-gradient-from: #7c3aed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 58 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-card {
  --tw-gradient-to: oklch(var(--card) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), oklch(var(--card) / 1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-blue-50 {
  --tw-gradient-to: #eff6ff var(--tw-gradient-to-position);
}
.to-cm-blue {
  --tw-gradient-to: oklch(var(--primary) / 1) var(--tw-gradient-to-position);
}
.to-cm-blue-vivid {
  --tw-gradient-to: oklch(var(--primary) / 1) var(--tw-gradient-to-position);
}
.to-primary {
  --tw-gradient-to: oklch(var(--primary) / 1) var(--tw-gradient-to-position);
}
.bg-clip-text {
  background-clip: text;
}
.fill-background {
  fill: oklch(var(--background) / 1);
}
.fill-current {
  fill: currentColor;
}
.fill-down {
  fill: oklch(var(--down) / 1);
}
.fill-muted-foreground {
  fill: oklch(var(--muted-foreground) / 1);
}
.fill-primary {
  fill: oklch(var(--primary) / 1);
}
.fill-up {
  fill: oklch(var(--up) / 1);
}
.stroke-border {
  stroke: oklch(var(--border) / 1);
}
.stroke-down {
  stroke: oklch(var(--down) / 1);
}
.stroke-muted-foreground {
  stroke: oklch(var(--muted-foreground) / 1);
}
.stroke-up {
  stroke: oklch(var(--up) / 1);
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-\\[92\\%_40\\%\\] {
  object-position: 92% 40%;
}
.object-top {
  object-position: top;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[1px\\] {
  padding: 1px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-28 {
  padding-top: 7rem;
  padding-bottom: 7rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-14 {
  padding-bottom: 3.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-11 {
  padding-right: 2.75rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-24 {
  padding-top: 6rem;
}
.pt-28 {
  padding-top: 7rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-7 {
  padding-top: 1.75rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-9 {
  padding-top: 2.25rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-middle {
  vertical-align: middle;
}
.font-display {
  font-family: Sora, ui-sans-serif, system-ui, sans-serif;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: Sora, ui-sans-serif, system-ui, sans-serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[0\\.8rem\\] {
  font-size: 0.8rem;
}
.text-\\[10\\.5px\\] {
  font-size: 10.5px;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11\\.5px\\] {
  font-size: 11.5px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12\\.5px\\] {
  font-size: 12.5px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13\\.5px\\] {
  font-size: 13.5px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14\\.5px\\] {
  font-size: 14.5px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[36px\\] {
  font-size: 36px;
}
.text-\\[7px\\] {
  font-size: 7px;
}
.text-\\[8\\.5px\\] {
  font-size: 8.5px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[9\\.5px\\] {
  font-size: 9.5px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-\\[1\\.08\\] {
  line-height: 1.08;
}
.leading-\\[1\\.15\\] {
  line-height: 1.15;
}
.leading-\\[1\\.65\\] {
  line-height: 1.65;
}
.leading-\\[1\\.75\\] {
  line-height: 1.75;
}
.leading-\\[1\\.7\\] {
  line-height: 1.7;
}
.leading-\\[1\\.85\\] {
  line-height: 1.85;
}
.leading-\\[1\\.8\\] {
  line-height: 1.8;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.12em\\] {
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.14em\\] {
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.16em\\] {
  letter-spacing: 0.16em;
}
.tracking-\\[0\\.18em\\] {
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.22em\\] {
  letter-spacing: 0.22em;
}
.tracking-\\[0\\.25em\\] {
  letter-spacing: 0.25em;
}
.tracking-\\[0\\.35em\\] {
  letter-spacing: 0.35em;
}
.tracking-\\[0\\.4em\\] {
  letter-spacing: 0.4em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-\\[var\\(--cm-border\\)\\] {
  color: var(--cm-border);
}
.text-accent {
  --tw-text-opacity: 1;
  color: oklch(var(--accent) / var(--tw-text-opacity, 1));
}
.text-accent-foreground {
  --tw-text-opacity: 1;
  color: oklch(var(--accent-foreground) / var(--tw-text-opacity, 1));
}
.text-amber-200 {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}
.text-amber-300 {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-background {
  --tw-text-opacity: 1;
  color: oklch(var(--background) / var(--tw-text-opacity, 1));
}
.text-blue-200 {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.text-brand-ink {
  --tw-text-opacity: 1;
  color: oklch(var(--brand-ink) / var(--tw-text-opacity, 1));
}
.text-card-foreground {
  --tw-text-opacity: 1;
  color: oklch(var(--card-foreground) / var(--tw-text-opacity, 1));
}
.text-current {
  color: currentColor;
}
.text-destructive {
  --tw-text-opacity: 1;
  color: oklch(var(--down) / var(--tw-text-opacity, 1));
}
.text-destructive-foreground {
  --tw-text-opacity: 1;
  color: oklch(var(--foreground) / var(--tw-text-opacity, 1));
}
.text-dim {
  --tw-text-opacity: 1;
  color: oklch(var(--dim) / var(--tw-text-opacity, 1));
}
.text-down {
  --tw-text-opacity: 1;
  color: oklch(var(--down) / var(--tw-text-opacity, 1));
}
.text-emerald-100 {
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity, 1));
}
.text-emerald-300 {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-400\\/90 {
  color: rgb(52 211 153 / 0.9);
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-foreground {
  --tw-text-opacity: 1;
  color: oklch(var(--foreground) / var(--tw-text-opacity, 1));
}
.text-foreground\\/50 {
  color: oklch(var(--foreground) / 0.5);
}
.text-foreground\\/85 {
  color: oklch(var(--foreground) / 0.85);
}
.text-foreground\\/90 {
  color: oklch(var(--foreground) / 0.9);
}
.text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-muted-foreground {
  --tw-text-opacity: 1;
  color: oklch(var(--muted-foreground) / var(--tw-text-opacity, 1));
}
.text-muted-foreground\\/40 {
  color: oklch(var(--muted-foreground) / 0.4);
}
.text-muted-foreground\\/50 {
  color: oklch(var(--muted-foreground) / 0.5);
}
.text-muted-foreground\\/60 {
  color: oklch(var(--muted-foreground) / 0.6);
}
.text-muted-foreground\\/80 {
  color: oklch(var(--muted-foreground) / 0.8);
}
.text-popover-foreground {
  --tw-text-opacity: 1;
  color: oklch(var(--popover-foreground) / var(--tw-text-opacity, 1));
}
.text-primary {
  --tw-text-opacity: 1;
  color: oklch(var(--primary) / var(--tw-text-opacity, 1));
}
.text-primary-foreground {
  --tw-text-opacity: 1;
  color: oklch(var(--primary-foreground) / var(--tw-text-opacity, 1));
}
.text-primary\\/10 {
  color: oklch(var(--primary) / 0.1);
}
.text-primary\\/25 {
  color: oklch(var(--primary) / 0.25);
}
.text-primary\\/40 {
  color: oklch(var(--primary) / 0.4);
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-red-200 {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}
.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground {
  --tw-text-opacity: 1;
  color: oklch(var(--secondary-foreground) / var(--tw-text-opacity, 1));
}
.text-sky-300 {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity, 1));
}
.text-surface {
  --tw-text-opacity: 1;
  color: oklch(var(--surface) / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-up {
  --tw-text-opacity: 1;
  color: oklch(var(--up) / var(--tw-text-opacity, 1));
}
.text-violet-400 {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.text-violet-700 {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-violet-800 {
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-warning {
  --tw-text-opacity: 1;
  color: oklch(var(--warning) / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/40 {
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/45 {
  color: rgb(255 255 255 / 0.45);
}
.text-white\\/60 {
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/65 {
  color: rgb(255 255 255 / 0.65);
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75 {
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-300 {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-zinc-100 {
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity, 1));
}
.text-zinc-200 {
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity, 1));
}
.text-zinc-300 {
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity, 1));
}
.text-zinc-400 {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.text-zinc-500 {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.text-zinc-600 {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
}
.text-zinc-900 {
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.accent-\\[oklch\\(var\\(--primary\\)\\)\\] {
  accent-color: oklch(var(--primary));
}
.accent-primary {
  accent-color: oklch(var(--primary) / 1);
}
.opacity-0 {
  opacity: 0;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-35 {
  opacity: 0.35;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.opacity-\\[0\\.12\\] {
  opacity: 0.12;
}
.opacity-\\[0\\.14\\] {
  opacity: 0.14;
}
.mix-blend-screen {
  mix-blend-mode: screen;
}
.mix-blend-color {
  mix-blend-mode: color;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_40px_-20px_rgba\\(11\\2c 20\\2c 38\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 12px 40px -20px rgba(11,20,38,0.12);
  --tw-shadow-colored: 0 12px 40px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_32px_80px_-24px_rgba\\(29\\2c 45\\2c 63\\2c 0\\.45\\)\\] {
  --tw-shadow: 0 32px 80px -24px rgba(29,45,63,0.45);
  --tw-shadow-colored: 0 32px 80px -24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-brand {
  --tw-shadow: var(--shadow-brand);
  --tw-shadow-colored: var(--shadow-brand);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card {
  --tw-shadow: var(--shadow-card);
  --tw-shadow-colored: var(--shadow-card);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-panel {
  --tw-shadow: var(--shadow-panel);
  --tw-shadow-colored: var(--shadow-panel);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[var\\(--shadow-panel\\)\\] {
  --tw-shadow-color: var(--shadow-panel);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-card {
  --tw-shadow-color: oklch(var(--card) / 1);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-8 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-background {
  --tw-ring-opacity: 1;
  --tw-ring-color: oklch(var(--background) / var(--tw-ring-opacity, 1));
}
.ring-border {
  --tw-ring-opacity: 1;
  --tw-ring-color: oklch(var(--border) / var(--tw-ring-opacity, 1));
}
.ring-cm-blue\\/15 {
  --tw-ring-color: oklch(var(--primary) / 0.15);
}
.ring-emerald-50\\/60 {
  --tw-ring-color: rgb(236 253 245 / 0.6);
}
.ring-primary\\/40 {
  --tw-ring-color: oklch(var(--primary) / 0.4);
}
.ring-ring {
  --tw-ring-opacity: 1;
  --tw-ring-color: oklch(var(--ring) / var(--tw-ring-opacity, 1));
}
.ring-offset-background {
  --tw-ring-offset-color: oklch(var(--background) / 1);
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\] {
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[3px\\] {
  --tw-backdrop-blur: blur(3px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[border-color\\2c box-shadow\\] {
  transition-property: border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[color\\2c background-color\\2c border-color\\2c box-shadow\\2c opacity\\2c transform\\2c filter\\] {
  transition-property: color,background-color,border-color,box-shadow,opacity,transform,filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\] {
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0 {
  --tw-enter-opacity: 0;
}
.zoom-in-95 {
  --tw-enter-scale: .95;
}
.duration-1000 {
  animation-duration: 1000ms;
}
.duration-200 {
  animation-duration: 200ms;
}
.duration-300 {
  animation-duration: 300ms;
}
.duration-500 {
  animation-duration: 500ms;
}
.duration-700 {
  animation-duration: 700ms;
}
.ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.\\!paused {
  animation-play-state: paused !important;
}
.paused {
  animation-play-state: paused;
}
.\\[-ms-overflow-style\\:none\\] {
  -ms-overflow-style: none;
}
.\\[animation-delay\\:-8s\\] {
  animation-delay: -8s;
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}

/* ------------------------------------------------------------------ *
 * PaisaCX design tokens. Channels are "r g b" so Tailwind opacity     *
 * modifiers (bg-primary/10) work. Dark is the default theme; the      *
 * \`.light\` class on <html> switches to the mint light theme.          *
 * ------------------------------------------------------------------ */
:root,
.dark {
  color-scheme: dark;
  --radius: 0.5rem;

  --brand-emerald: 0.668 0.142 164;
  --brand-green: 0.787 0.212 147;
  --brand-lime: 0.821 0.242 141;
  --brand-teal: 0.415 0.069 207;
  --brand-ink: 0.183 0.023 249;

  --background: 0.13 0.016 245;
  --foreground: 0.94 0.01 210;
  --surface: 0.175 0.02 240;
  --surface-2: 0.225 0.024 235;
  --page: 0.148 0.0176 242;
  --card: 0.175 0.02 240;
  --card-foreground: 0.94 0.01 210;
  --popover: 0.21 0.024 235;
  --popover-foreground: 0.94 0.01 210;
  --primary: 0.74 0.18 153;
  --primary-deep: 0.66 0.17 153;
  --primary-foreground: 0.183 0.023 249;
  --secondary: 0.26 0.028 230;
  --secondary-foreground: 0.94 0.01 210;
  --muted: 0.26 0.028 230;
  --muted-foreground: 0.68 0.024 220;
  --dim: 0.55 0.022 220;
  --accent: 0.415 0.069 207;
  --accent-foreground: 0.96 0.01 190;
  --up: 0.76 0.2 146;
  --down: 0.65 0.21 18;
  --warning: 0.8 0.15 85;
  --border: 0.28 0.028 230;
  --line-strong: 0.34 0.03 230;
  --input: 0.225 0.024 235;
  --ring: 0.74 0.18 153;

  --gradient-brand: linear-gradient(120deg, oklch(var(--brand-emerald)), oklch(var(--brand-lime)));
  --gradient-text: var(--gradient-brand);
  --shadow-panel: 0 24px 60px -30px oklch(0.06 0.03 240 / 0.9);
  --shadow-brand: 0 18px 44px -18px oklch(0.74 0.18 153 / 0.6);
  --shadow-card: 0 12px 32px -20px oklch(0.06 0.03 240 / 0.85);
  --shadow-card-hover: 0 20px 44px -18px oklch(0.06 0.03 240 / 0.9), 0 0 0 1px oklch(var(--primary) / 0.28);
  --table-head: oklch(var(--surface-2) / 0.4);

  /* Legacy PaisaCX variables, pointed at the PaisaCX palette */
  --cm-blue: oklch(var(--primary));
  --cm-blue-deep: oklch(var(--primary-deep));
  --cm-blue-hover: oklch(var(--primary-deep));
  --cm-blue-vivid: oklch(var(--primary));
  --cm-navy: oklch(var(--foreground));
  --cm-grey: oklch(var(--muted-foreground));
  --cm-orange: oklch(var(--warning));
  --cm-lavender: oklch(var(--surface-2));
  --cm-lavender-2: oklch(var(--surface-2));
  --cm-card-soft: oklch(var(--surface));
  --cm-surface: oklch(var(--page));
  --cm-border: oklch(var(--border));
  --cm-green: oklch(var(--up));
  --cm-red: oklch(var(--down));
}

.light {
  color-scheme: light;
  --background: 0.945 0.028 158;
  --foreground: 0.22 0.04 165;
  --surface: 0.975 0.02 152;
  --surface-2: 0.915 0.035 156;
  --page: 0.957 0.0248 155.6;
  --card: 0.975 0.02 152;
  --card-foreground: 0.22 0.04 165;
  --popover: 0.985 0.016 150;
  --popover-foreground: 0.22 0.04 165;
  --primary: 0.5 0.135 158;
  --primary-deep: 0.44 0.125 158;
  --primary-foreground: 0.18 0.03 165;
  --secondary: 0.91 0.04 162;
  --secondary-foreground: 0.24 0.045 165;
  --muted: 0.91 0.032 158;
  --muted-foreground: 0.42 0.04 170;
  --dim: 0.55 0.035 168;
  --accent: 0.9 0.055 165;
  --accent-foreground: 0.28 0.06 168;
  --up: 0.5 0.15 150;
  --down: 0.55 0.2 22;
  --warning: 0.64 0.14 75;
  --border: 0.84 0.045 158;
  --line-strong: 0.78 0.05 158;
  --input: 0.86 0.04 156;
  --ring: 0.5 0.135 158;

  --gradient-brand: linear-gradient(120deg, oklch(0.55 0.145 163), oklch(0.72 0.2 145));
  --gradient-text: linear-gradient(120deg, oklch(0.42 0.12 166), oklch(0.52 0.16 148));
  --shadow-panel: 0 22px 48px -26px oklch(0.42 0.08 160 / 0.28);
  --shadow-brand: 0 14px 34px -14px oklch(0.5 0.14 158 / 0.4);
  --shadow-card: 0 1px 0 oklch(0.55 0.1 160 / 0.1), 0 12px 30px -16px oklch(0.4 0.08 160 / 0.22);
  --shadow-card-hover: 0 1px 0 oklch(0.55 0.12 160 / 0.14), 0 22px 42px -16px oklch(0.48 0.12 158 / 0.28);
  --table-head: oklch(0.93 0.03 156);
}

* {
  border-color: oklch(var(--border));
}

html {
  overflow-x: hidden;
  max-width: 100%;
}

html, body {
  margin: 0;
  padding: 0;
  background: oklch(var(--page));
  color: oklch(var(--foreground));
  font-family: 'Sora', ui-sans-serif, system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  overflow-x: hidden;
  max-width: 100vw;
  min-height: 100vh;
  min-height: 100dvh;
}

.light body {
  background-image:
    radial-gradient(ellipse 80% 50% at 10% -10%, oklch(var(--brand-lime) / 0.16), transparent 55%),
    radial-gradient(ellipse 70% 45% at 95% 0%, oklch(var(--brand-emerald) / 0.14), transparent 50%);
}

#root {
  overflow-x: clip;
  max-width: 100%;
}

button, input, select, textarea {
  font-family: inherit;
}

h1, h2, h3, h4 {
  font-family: 'Sora', ui-sans-serif, system-ui, sans-serif;
}

.num,
.tabular-nums,
[class*="tabular-nums"] {
  font-family: 'Sora', ui-sans-serif, system-ui, sans-serif !important;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: normal;
}

/* Inputs follow the theme even when components hardcode light colours */
input, select, textarea {
  color: inherit;
}
input::placeholder, textarea::placeholder {
  color: oklch(var(--dim));
}
select option {
  background: oklch(var(--popover));
  color: oklch(var(--popover-foreground));
}

/* Safe areas for notched phones / mobile browser chrome */
.pb-safe {
  padding-bottom: max(1rem, env(safe-area-inset-bottom, 0px));
}

.pt-safe {
  padding-top: max(0px, env(safe-area-inset-top, 0px));
}

.px-safe {
  padding-left: max(0px, env(safe-area-inset-left, 0px));
  padding-right: max(0px, env(safe-area-inset-right, 0px));
}

/* Shared modal shell — scrollable on small viewports */
.cm-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding:
    max(12px, env(safe-area-inset-top, 0px))
    max(12px, env(safe-area-inset-right, 0px))
    max(12px, env(safe-area-inset-bottom, 0px))
    max(12px, env(safe-area-inset-left, 0px));
}

@media (min-width: 640px) {
  .cm-modal-overlay {
    align-items: center;
    padding:
      max(16px, env(safe-area-inset-top, 0px))
      max(16px, env(safe-area-inset-right, 0px))
      max(16px, env(safe-area-inset-bottom, 0px))
      max(16px, env(safe-area-inset-left, 0px));
  }
}

.cm-modal-panel {
  width: 100%;
  max-height: none;
  margin: auto 0;
}

@media (min-width: 640px) {
  .cm-modal-panel {
    max-height: min(92dvh, 100%);
  }
}

::selection {
  background: oklch(var(--primary));
  color: oklch(var(--primary-foreground));
}

/* Utility classes */
.cm-container {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  padding-left: max(16px, env(safe-area-inset-left, 0px));
  padding-right: max(16px, env(safe-area-inset-right, 0px));
  width: 100%;
}

@media (min-width: 640px) {
  .cm-container {
    padding-left: max(24px, env(safe-area-inset-left, 0px));
    padding-right: max(24px, env(safe-area-inset-right, 0px));
  }
}

@media (min-width: 1024px) {
  .cm-container { padding-left: 32px; padding-right: 32px; }
}

.cm-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 26px;
  background-image: var(--gradient-brand);
  color: oklch(var(--brand-ink));
  font-weight: 600;
  font-size: 15px;
  border-radius: var(--radius);
  transition: filter 200ms ease, transform 200ms ease, box-shadow 200ms ease;
  box-shadow: var(--shadow-brand);
  cursor: pointer;
  border: 0;
}
.cm-btn-primary:hover {
  filter: brightness(1.08) saturate(1.05);
  transform: translateY(-1px);
}
.cm-btn-primary:active { transform: scale(0.98); }

.cm-btn-outline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 25px;
  background: oklch(var(--surface-2));
  color: oklch(var(--foreground));
  font-weight: 600;
  font-size: 15px;
  border-radius: var(--radius);
  transition: all 200ms ease;
  border: 1px solid oklch(var(--primary) / 0.4);
  cursor: pointer;
}
.cm-btn-outline:hover {
  border-color: oklch(var(--primary));
  background: oklch(var(--primary) / 0.1);
  color: oklch(var(--primary));
}

.cm-section-title {
  font-size: 32px;
  line-height: 1.15;
  font-weight: 600;
  color: oklch(var(--foreground));
}

@media (min-width: 768px) {
  .cm-section-title { font-size: 44px; }
}

.cm-eyebrow {
  color: oklch(var(--muted-foreground));
  font-size: 16px;
  line-height: 1.6;
}

/* Animations */
@keyframes cm-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}
.cm-float { animation: cm-float 6s ease-in-out infinite; }

@keyframes cm-fade-up {
  from { opacity: 0; transform: translateY(24px); }
  to { opacity: 1; transform: translateY(0); }
}
.cm-fade-up {
  animation: cm-fade-up 700ms ease-out both;
}

@keyframes cm-spin-slow {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.cm-spin-slow { animation: cm-spin-slow 40s linear infinite; }
.cm-spin-reverse { animation: cm-spin-slow 50s linear infinite reverse; }
.cm-spin-fast { animation: cm-spin-slow 22s linear infinite; }

@keyframes cm-orbit-pulse {
  0%, 100% { transform: scale(1); opacity: 0.9; box-shadow: 0 0 0 0 oklch(var(--primary) / 0.35); }
  50% { transform: scale(1.35); opacity: 1; box-shadow: 0 0 18px 4px oklch(var(--primary) / 0.35); }
}
.cm-orbit-pulse { animation: cm-orbit-pulse 2.4s ease-in-out infinite; }

@keyframes cm-ring-breathe {
  0%, 100% { transform: scale(1); opacity: 0.55; }
  50% { transform: scale(1.03); opacity: 0.95; }
}
.cm-ring-breathe { animation: cm-ring-breathe 5s ease-in-out infinite; transform-origin: center; }
.cm-ring-breathe-slow { animation: cm-ring-breathe 7s ease-in-out infinite; transform-origin: center; animation-delay: 0.6s; }

@keyframes cm-marquee {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}
.cm-marquee-track {
  animation: cm-marquee 45s linear infinite;
  will-change: transform;
}
.cm-ticker-marquee {
  overflow: hidden;
  contain: layout style;
}
.cm-ticker-marquee:hover .cm-marquee-track {
  animation-play-state: paused;
}

@media (prefers-reduced-motion: reduce) {
  .cm-marquee-track { animation: none; }
}

.cm-no-scrollbar::-webkit-scrollbar { display: none; }
.cm-no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

/* Scroll-triggered entrance animations */
.cm-reveal {
  opacity: 0;
  transition-property: opacity, transform, filter;
  transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
  will-change: opacity, transform;
  filter: blur(2px);
}
.cm-reveal.is-in {
  opacity: 1;
  filter: blur(0);
  transform: translate3d(0, 0, 0) scale(1);
}

.cm-reveal-fade-up        { transform: translate3d(0, 36px, 0); }
.cm-reveal-fade           { transform: translate3d(0, 0, 0); }
.cm-reveal-fade-left      { transform: translate3d(-40px, 0, 0); }
.cm-reveal-fade-right     { transform: translate3d(40px, 0, 0); }
.cm-reveal-zoom-soft      { transform: scale(0.96); }

@media (prefers-reduced-motion: reduce) {
  .cm-reveal, .cm-reveal.is-in {
    opacity: 1 !important;
    transform: none !important;
    filter: none !important;
    transition: none !important;
  }
}

.cm-hover-lift {
  transition: transform 500ms cubic-bezier(0.22, 1, 0.36, 1),
              box-shadow 500ms cubic-bezier(0.22, 1, 0.36, 1);
  will-change: transform;
}
.cm-hover-lift:hover {
  transform: translateY(-6px);
}

@keyframes cm-shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
.cm-shimmer {
  background: linear-gradient(90deg, transparent, rgb(255 255 255 / 0.18), transparent);
  background-size: 200% 100%;
  animation: cm-shimmer 3s ease-in-out infinite;
}

@keyframes cm-glow-breathe {
  0%, 100% { box-shadow: 0 0 0 0 oklch(var(--primary) / 0); opacity: 0.9; }
  50%      { box-shadow: 0 0 24px 4px oklch(var(--primary) / 0.22); opacity: 1; }
}
.cm-glow-breathe { animation: cm-glow-breathe 3.5s ease-in-out infinite; }

@keyframes cm-tilt-in {
  from { opacity: 0; transform: perspective(900px) rotateX(8deg) translateY(16px); }
  to   { opacity: 1; transform: perspective(900px) rotateX(0) translateY(0); }
}
.cm-tilt-in { animation: cm-tilt-in 1.1s cubic-bezier(0.22, 1, 0.36, 1) both; }

/* Marketing helpers still used by secondary public pages */
.cm-landing-hero-bg {
  background:
    radial-gradient(ellipse 80% 60% at 85% 20%, oklch(var(--primary) / 0.14) 0%, transparent 55%),
    radial-gradient(ellipse 50% 40% at 10% 80%, oklch(var(--primary) / 0.06) 0%, transparent 50%),
    oklch(var(--page));
}

.cm-landing-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: oklch(var(--primary));
  background: oklch(var(--primary) / 0.1);
  border: 1px solid oklch(var(--primary) / 0.4);
}

.cm-landing-hero-title {
  font-size: clamp(34px, 5vw, 56px);
  line-height: 1.1;
  font-weight: 700;
  color: oklch(var(--foreground));
}

.cm-landing-hero-accent {
  background-image: var(--gradient-text);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.cm-landing-feature-card,
.cm-landing-product-card {
  border: 1px solid oklch(var(--border));
  border-radius: 0.75rem;
  background-color: oklch(var(--surface));
  background-image: linear-gradient(to bottom right, oklch(var(--primary) / 0.2), oklch(var(--surface)) 42%, oklch(var(--surface)));
  box-shadow: var(--shadow-card);
  transition: border-color 300ms ease, box-shadow 300ms ease, transform 300ms ease;
}
.cm-landing-feature-card:hover,
.cm-landing-product-card:hover {
  border-color: oklch(var(--primary) / 0.45);
  box-shadow: var(--shadow-card-hover);
  transform: translateY(-4px);
}

.cm-ticker-exchange {
  background: oklch(var(--surface));
  border-color: oklch(var(--border));
}

.cm-landing-section-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: oklch(var(--primary));
}

.cm-landing-grid-bg {
  background-image:
    linear-gradient(oklch(var(--border) / 0.25) 1px, transparent 1px),
    linear-gradient(90deg, oklch(var(--border) / 0.25) 1px, transparent 1px);
  background-size: 48px 48px;
}

.cm-landing-section {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
@media (min-width: 1024px) {
  .cm-landing-section {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
}

.cm-landing-section-title {
  font-size: clamp(26px, 4vw, 44px);
  line-height: 1.15;
  font-weight: 600;
  color: oklch(var(--foreground));
}

.cm-landing-section-alt {
  background: oklch(var(--page));
}

.cm-landing-new-badge {
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.12em;
  padding: 3px 6px;
  border-radius: 4px;
  color: oklch(var(--brand-ink));
  background-image: var(--gradient-brand);
}

.cm-landing-cta-band {
  background-image: var(--gradient-brand);
  color: oklch(var(--brand-ink));
}

.cm-landing-mesh {
  background-image:
    radial-gradient(at 90% 10%, oklch(var(--primary) / 0.14) 0%, transparent 45%),
    radial-gradient(at 5% 90%, oklch(var(--primary) / 0.08) 0%, transparent 40%);
}

/* ------------------------------------------------------------------ *
 * PaisaCX utilities                                                   *
 * ------------------------------------------------------------------ */
.section-band { background-color: oklch(var(--page)); }

.brand-gradient { background-image: var(--gradient-brand); }
:is(button, a).brand-gradient {
  transition: filter 0.2s ease, opacity 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}
:is(button, a).brand-gradient:hover {
  filter: brightness(1.08) saturate(1.05);
  box-shadow: var(--shadow-brand);
}
:is(button, a).brand-gradient:active {
  filter: brightness(0.96);
  transform: scale(0.98);
}

.brand-text {
  background-image: var(--gradient-text);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.glass-panel {
  background-color: oklch(var(--surface) / 0.78);
  backdrop-filter: blur(18px);
  border: 1px solid oklch(var(--border));
  box-shadow: var(--shadow-panel);
}

.panel-gradient {
  background-color: oklch(var(--surface));
  background-image: linear-gradient(to bottom right, oklch(var(--primary) / 0.2), oklch(var(--surface)) 42%, oklch(var(--surface)));
}

.light .panel-gradient,
.light .interactive-tile {
  background-image: linear-gradient(
    to bottom right,
    oklch(var(--brand-lime) / 0.22),
    color-mix(in oklab, oklch(var(--brand-emerald)) 10%, oklch(var(--surface))) 38%,
    oklch(var(--surface))
  );
}

.interactive-tile {
  position: relative;
  background-color: oklch(var(--surface));
  background-image: linear-gradient(to bottom right, oklch(var(--primary) / 0.2), oklch(var(--surface)) 42%, oklch(var(--surface)));
  box-shadow: var(--shadow-card);
  transition:
    transform 0.28s cubic-bezier(0.22, 1, 0.36, 1),
    border-color 0.28s ease,
    box-shadow 0.28s ease;
  will-change: transform;
}
.interactive-tile:hover {
  transform: translateY(-4px);
  border-color: color-mix(in oklab, oklch(var(--primary)) 45%, oklch(var(--border)));
  background-image: linear-gradient(
    to bottom right,
    oklch(var(--primary) / 0.28),
    oklch(var(--surface)) 40%,
    color-mix(in oklab, oklch(var(--surface-2)) 55%, oklch(var(--surface)))
  );
  box-shadow: var(--shadow-card-hover);
}
.interactive-tile:active {
  transform: translateY(-1px);
  transition-duration: 0.12s;
}
.interactive-tile .tile-icon {
  background-image: linear-gradient(145deg, oklch(var(--brand-emerald) / 0.22), oklch(var(--brand-lime) / 0.14));
  transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1), filter 0.28s ease;
}
.interactive-tile:hover .tile-icon {
  transform: scale(1.08);
  filter: brightness(1.15);
}

.interactive-row {
  transition: background-color 0.2s ease;
}
.interactive-row:hover {
  background-color: oklch(var(--surface-2) / 0.8);
}

@media (prefers-reduced-motion: reduce) {
  .interactive-tile,
  .interactive-tile .tile-icon,
  .interactive-row {
    transition: none;
  }
  .interactive-tile:hover,
  .interactive-tile:active,
  .interactive-tile:hover .tile-icon {
    transform: none;
  }
}

.shadow-brand { box-shadow: var(--shadow-brand); }

.hero-grid {
  background-image:
    linear-gradient(to right, oklch(var(--border) / 0.25) 1px, transparent 1px),
    linear-gradient(to bottom, oklch(var(--border) / 0.25) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: linear-gradient(to bottom, black 0%, black 70%, transparent 100%);
}

@keyframes hero-rise {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: none; }
}
.hero-copy > * { animation: hero-rise 0.6s ease-out both; }
.hero-copy > *:nth-child(1) { animation-delay: 0.04s; }
.hero-copy > *:nth-child(2) { animation-delay: 0.12s; }
.hero-copy > *:nth-child(3) { animation-delay: 0.2s; }
.hero-copy > *:nth-child(4) { animation-delay: 0.28s; }
.hero-copy > *:nth-child(5) { animation-delay: 0.36s; }

.hero-video { filter: saturate(0.85) brightness(0.72) contrast(1.1); }
@media (min-width: 640px) {
  .hero-video { filter: saturate(0.85) brightness(0.78) contrast(1.1); }
}
@media (prefers-reduced-motion: reduce) {
  .hero-copy > * { animation: none; }
}

.table-head {
  background-color: var(--table-head);
  border-bottom: 1px solid oklch(var(--border));
  color: oklch(var(--muted-foreground));
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

@keyframes fade-in-soft {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: none; }
}
.page-fade { animation: fade-in-soft 0.35s ease-out; }

@keyframes shake-x {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-7px); }
  40% { transform: translateX(6px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(2px); }
}
.animate-shake { animation: shake-x 0.4s ease-in-out; }

@keyframes shimmer-x {
  from { background-position: -200% 0; }
  to { background-position: 200% 0; }
}
.skeleton {
  border-radius: 6px;
  background: linear-gradient(90deg, oklch(var(--surface-2) / 0.8) 25%, oklch(var(--border) / 0.9) 50%, oklch(var(--surface-2) / 0.8) 75%);
  background-size: 200% 100%;
  animation: shimmer-x 1.4s linear infinite;
}

.table-head button {
  text-transform: inherit;
  letter-spacing: inherit;
  font-weight: inherit;
}

.terminal-row {
  display: grid;
  align-items: center;
  border-bottom: 1px solid oklch(var(--border) / 0.7);
  transition: background-color 0.15s ease;
}
.terminal-row:hover { background-color: oklch(var(--surface-2) / 0.6); }

.chart-grid {
  background-image:
    linear-gradient(to right, oklch(var(--border) / 0.35) 1px, transparent 1px),
    linear-gradient(to bottom, oklch(var(--border) / 0.35) 1px, transparent 1px);
  background-size: 44px 44px;
}
.cta-grid {
  background-image:
    linear-gradient(to right, oklch(var(--primary) / 0.08) 1px, transparent 1px),
    linear-gradient(to bottom, oklch(var(--primary) / 0.08) 1px, transparent 1px);
  background-size: 36px 36px;
}

@keyframes flash-up { 0% { background-color: oklch(var(--up) / 0.26); } 100% { background-color: transparent; } }
@keyframes flash-down { 0% { background-color: oklch(var(--down) / 0.26); } 100% { background-color: transparent; } }
@keyframes mesh-drift {
  0% { transform: translate3d(-4%, -2%, 0) scale(1.05); }
  50% { transform: translate3d(5%, 3%, 0) scale(1.15); }
  100% { transform: translate3d(-4%, -2%, 0) scale(1.05); }
}
@keyframes marquee-x { from { transform: translateX(0); } to { transform: translateX(-50%); } }
@keyframes float { 0%,100% { transform: translateY(0) } 50% { transform: translateY(-14px) } }
.flash-up { animation: flash-up 0.9s ease-out; }
.flash-down { animation: flash-down 0.9s ease-out; }
.animate-mesh { animation: mesh-drift 18s ease-in-out infinite; }
.animate-marquee { animation: marquee-x 42s linear infinite; }
@media (prefers-reduced-motion: reduce) {
  .motion-safe\\:animate-mesh, .animate-mesh, .animate-marquee { animation: none; }
}

.ticker-rail { contain: strict; overflow-x: clip; overflow-y: hidden; }
.ticker-track { width: max-content; max-width: none; }

.feature-art-dark { mix-blend-mode: lighten; }
.feature-art-light { display: none; }
.light .feature-art-dark { display: none; }
.light .feature-art-light { display: block; mix-blend-mode: normal; }

/* Panels lift off the page in both themes */
:is(.bg-surface, .bg-surface\\/40, .bg-surface\\/50, .bg-card):is(.rounded-lg, .rounded-xl, .rounded-2xl, .rounded-3xl).border {
  background-color: oklch(var(--surface));
  box-shadow: var(--shadow-card);
}

.light .interactive-tile:hover {
  background-image: linear-gradient(
    to bottom right,
    oklch(var(--brand-lime) / 0.3),
    color-mix(in oklab, oklch(var(--brand-emerald)) 14%, oklch(var(--surface))) 36%,
    oklch(var(--surface-2))
  );
}
.light :is(input, select, textarea):is(.bg-surface-2, .bg-background) {
  background-color: oklch(var(--surface));
  border-color: oklch(var(--input));
}
.light :is(input, select, textarea):focus {
  border-color: oklch(var(--primary));
  box-shadow: 0 0 0 3px oklch(var(--primary) / 0.18);
}
.light :is(button, a).bg-surface-2.border:not(:hover) {
  background-color: oklch(var(--surface));
  border-color: oklch(var(--input));
  box-shadow: 0 1px 2px oklch(0.4 0.06 160 / 0.08);
}
.light footer {
  background-color: color-mix(in oklab, oklch(var(--surface)) 70%, oklch(var(--surface-2)));
  border-color: oklch(var(--border));
}
.light header > div:first-child {
  background-color: oklch(var(--surface) / 0.88);
  box-shadow: 0 1px 0 oklch(var(--border)), 0 8px 24px -16px oklch(0.42 0.08 160 / 0.28);
}

/* Blog — admin rich editor + public article HTML */
.blog-rich-editor-area:empty::before {
  content: attr(data-placeholder);
  color: oklch(var(--dim));
  pointer-events: none;
}

.blog-rich-editor-area h2 {
  font-size: 1.35rem;
  font-weight: 700;
  margin: 1rem 0 0.5rem;
}
.blog-rich-editor-area h3 {
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0.85rem 0 0.4rem;
}
.blog-rich-editor-area blockquote {
  border-left: 3px solid oklch(var(--primary));
  padding-left: 1rem;
  margin: 0.75rem 0;
  color: oklch(var(--muted-foreground));
}
.blog-rich-editor-area ul,
.blog-rich-editor-area ol {
  padding-left: 1.5rem;
  margin: 0.5rem 0;
}
.blog-rich-editor-area figure.blog-video-embed,
.blog-rich-editor-area figure.blog-image-embed {
  margin: 0.75rem 0;
  max-width: 100%;
}
.blog-rich-editor-area img,
.blog-rich-editor-area video {
  display: block;
  width: 100%;
  max-width: 100%;
  min-height: 160px;
  border-radius: 8px;
  margin: 0;
  background: #000;
}
.blog-rich-editor-area figure.blog-video-embed[data-filename]::after {
  content: "Video: " attr(data-filename);
  display: block;
  margin-top: 0.35rem;
  font-size: 11px;
  color: oklch(var(--muted-foreground));
}
.blog-rich-editor-area a {
  color: oklch(var(--primary));
  text-decoration: underline;
}

.prose-blog,
.blog-body-html {
  color: oklch(var(--foreground));
  line-height: 1.75;
  font-size: 16px;
}
.prose-blog h2,
.blog-body-html h2 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 1.5rem 0 0.75rem;
  color: oklch(var(--foreground));
}
.prose-blog h3,
.blog-body-html h3 {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 1.25rem 0 0.5rem;
}
.prose-blog p,
.blog-body-html p {
  margin: 0.75rem 0;
}
.prose-blog ul,
.prose-blog ol,
.blog-body-html ul,
.blog-body-html ol {
  margin: 0.75rem 0;
  padding-left: 1.5rem;
}
.prose-blog blockquote,
.blog-body-html blockquote {
  border-left: 4px solid oklch(var(--primary));
  padding-left: 1rem;
  margin: 1rem 0;
  color: oklch(var(--muted-foreground));
  font-style: italic;
}
.prose-blog a,
.blog-body-html a {
  color: oklch(var(--primary));
  font-weight: 600;
  text-decoration: underline;
}
.prose-blog img,
.blog-body-html img,
.blog-image-embed img {
  width: 100%;
  border-radius: 12px;
  border: 1px solid oklch(var(--border));
  margin: 1.25rem 0;
}
.prose-blog video,
.blog-body-html video,
.blog-video-embed video {
  width: 100%;
  max-height: 480px;
  border-radius: 12px;
  border: 1px solid oklch(var(--border));
  background: #000;
  margin: 1.25rem 0;
}
.prose-blog figure,
.blog-body-html figure {
  margin: 1.25rem 0;
}
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}
.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button {
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button {
  --tw-text-opacity: 1;
  color: oklch(var(--foreground) / var(--tw-text-opacity, 1));
}
.placeholder\\:text-dim::placeholder {
  --tw-text-opacity: 1;
  color: oklch(var(--dim) / var(--tw-text-opacity, 1));
}
.placeholder\\:text-muted-foreground::placeholder {
  --tw-text-opacity: 1;
  color: oklch(var(--muted-foreground) / var(--tw-text-opacity, 1));
}
.placeholder\\:text-muted-foreground\\/70::placeholder {
  color: oklch(var(--muted-foreground) / 0.7);
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after {
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after {
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child {
  border-left-width: 1px;
}
.first\\:border-t-0:first-child {
  border-top-width: 0px;
}
.last\\:rounded-r-md:last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.last\\:border-0:last-child {
  border-width: 0px;
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.last\\:border-r-0:last-child {
  border-right-width: 0px;
}
.first-of-type\\:border-t-0:first-of-type {
  border-top-width: 0px;
}
.first-of-type\\:pt-0:first-of-type {
  padding-top: 0px;
}
.focus-within\\:relative:focus-within {
  position: relative;
}
.focus-within\\:z-20:focus-within {
  z-index: 20;
}
.focus-within\\:border-primary:focus-within {
  --tw-border-opacity: 1;
  border-color: oklch(var(--primary) / var(--tw-border-opacity, 1));
}
.hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.03\\]:hover {
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-cm-navy:hover {
  --tw-border-opacity: 1;
  border-color: oklch(var(--foreground) / var(--tw-border-opacity, 1));
}
.hover\\:border-down:hover {
  --tw-border-opacity: 1;
  border-color: oklch(var(--down) / var(--tw-border-opacity, 1));
}
.hover\\:border-primary:hover {
  --tw-border-opacity: 1;
  border-color: oklch(var(--primary) / var(--tw-border-opacity, 1));
}
.hover\\:border-primary\\/30:hover {
  border-color: oklch(var(--primary) / 0.3);
}
.hover\\:border-primary\\/40:hover {
  border-color: oklch(var(--primary) / 0.4);
}
.hover\\:border-primary\\/50:hover {
  border-color: oklch(var(--primary) / 0.5);
}
.hover\\:border-primary\\/60:hover {
  border-color: oklch(var(--primary) / 0.6);
}
.hover\\:border-primary\\/\\[0\\.45\\]:hover {
  border-color: oklch(var(--primary) / 0.45);
}
.hover\\:bg-accent:hover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--accent) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-500\\/25:hover {
  background-color: rgb(245 158 11 / 0.25);
}
.hover\\:bg-background\\/50:hover {
  background-color: oklch(var(--background) / 0.5);
}
.hover\\:bg-background\\/60:hover {
  background-color: oklch(var(--background) / 0.6);
}
.hover\\:bg-blue-500\\/25:hover {
  background-color: rgb(59 130 246 / 0.25);
}
.hover\\:bg-card:hover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--card) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cm-surface\\/30:hover {
  background-color: oklch(var(--page) / 0.3);
}
.hover\\:bg-destructive\\/80:hover {
  background-color: oklch(var(--down) / 0.8);
}
.hover\\:bg-destructive\\/85:hover {
  background-color: oklch(var(--down) / 0.85);
}
.hover\\:bg-down\\/10:hover {
  background-color: oklch(var(--down) / 0.1);
}
.hover\\:bg-down\\/20:hover {
  background-color: oklch(var(--down) / 0.2);
}
.hover\\:bg-down\\/25:hover {
  background-color: oklch(var(--down) / 0.25);
}
.hover\\:bg-down\\/90:hover {
  background-color: oklch(var(--down) / 0.9);
}
.hover\\:bg-emerald-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-line:hover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--border) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-line-strong:hover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--line-strong) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-muted:hover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--muted) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-muted\\/50:hover {
  background-color: oklch(var(--muted) / 0.5);
}
.hover\\:bg-primary:hover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--primary) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary-deep:hover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--primary-deep) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary\\/10:hover {
  background-color: oklch(var(--primary) / 0.1);
}
.hover\\:bg-primary\\/15:hover {
  background-color: oklch(var(--primary) / 0.15);
}
.hover\\:bg-primary\\/5:hover {
  background-color: oklch(var(--primary) / 0.05);
}
.hover\\:bg-primary\\/80:hover {
  background-color: oklch(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/85:hover {
  background-color: oklch(var(--primary) / 0.85);
}
.hover\\:bg-red-500\\/25:hover {
  background-color: rgb(239 68 68 / 0.25);
}
.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-900\\/50:hover {
  background-color: rgb(127 29 29 / 0.5);
}
.hover\\:bg-red-900\\/60:hover {
  background-color: rgb(127 29 29 / 0.6);
}
.hover\\:bg-secondary:hover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--secondary) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary\\/70:hover {
  background-color: oklch(var(--secondary) / 0.7);
}
.hover\\:bg-secondary\\/80:hover {
  background-color: oklch(var(--secondary) / 0.8);
}
.hover\\:bg-surface:hover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--surface) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-surface-2:hover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--surface-2) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-surface-2\\/30:hover {
  background-color: oklch(var(--surface-2) / 0.3);
}
.hover\\:bg-surface-2\\/40:hover {
  background-color: oklch(var(--surface-2) / 0.4);
}
.hover\\:bg-surface-2\\/50:hover {
  background-color: oklch(var(--surface-2) / 0.5);
}
.hover\\:bg-surface-2\\/60:hover {
  background-color: oklch(var(--surface-2) / 0.6);
}
.hover\\:bg-surface-2\\/70:hover {
  background-color: oklch(var(--surface-2) / 0.7);
}
.hover\\:bg-up\\/10:hover {
  background-color: oklch(var(--up) / 0.1);
}
.hover\\:bg-up\\/25:hover {
  background-color: oklch(var(--up) / 0.25);
}
.hover\\:bg-up\\/90:hover {
  background-color: oklch(var(--up) / 0.9);
}
.hover\\:bg-warning:hover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--warning) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-warning\\/10:hover {
  background-color: oklch(var(--warning) / 0.1);
}
.hover\\:bg-warning\\/20:hover {
  background-color: oklch(var(--warning) / 0.2);
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/15:hover {
  background-color: rgb(255 255 255 / 0.15);
}
.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-zinc-700\\/60:hover {
  background-color: rgb(63 63 70 / 0.6);
}
.hover\\:bg-zinc-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}
.hover\\:text-accent:hover {
  --tw-text-opacity: 1;
  color: oklch(var(--accent) / var(--tw-text-opacity, 1));
}
.hover\\:text-accent-foreground:hover {
  --tw-text-opacity: 1;
  color: oklch(var(--accent-foreground) / var(--tw-text-opacity, 1));
}
.hover\\:text-down:hover {
  --tw-text-opacity: 1;
  color: oklch(var(--down) / var(--tw-text-opacity, 1));
}
.hover\\:text-foreground:hover {
  --tw-text-opacity: 1;
  color: oklch(var(--foreground) / var(--tw-text-opacity, 1));
}
.hover\\:text-muted-foreground:hover {
  --tw-text-opacity: 1;
  color: oklch(var(--muted-foreground) / var(--tw-text-opacity, 1));
}
.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: oklch(var(--primary) / var(--tw-text-opacity, 1));
}
.hover\\:text-primary-foreground:hover {
  --tw-text-opacity: 1;
  color: oklch(var(--primary-foreground) / var(--tw-text-opacity, 1));
}
.hover\\:text-primary\\/80:hover {
  color: oklch(var(--primary) / 0.8);
}
.hover\\:text-surface-2:hover {
  --tw-text-opacity: 1;
  color: oklch(var(--surface-2) / var(--tw-text-opacity, 1));
}
.hover\\:text-warning:hover {
  --tw-text-opacity: 1;
  color: oklch(var(--warning) / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-70:hover {
  opacity: 0.7;
}
.hover\\:opacity-90:hover {
  opacity: 0.9;
}
.hover\\:opacity-95:hover {
  opacity: 0.95;
}
.hover\\:shadow-card:hover {
  --tw-shadow: var(--shadow-card);
  --tw-shadow-colored: var(--shadow-card);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-card-hover:hover {
  --tw-shadow: var(--shadow-card-hover);
  --tw-shadow-colored: var(--shadow-card-hover);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-card:hover {
  --tw-shadow-color: oklch(var(--card) / 1);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:ring-1:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.hover\\:ring-primary\\/50:hover {
  --tw-ring-color: oklch(var(--primary) / 0.5);
}
.hover\\:brightness-110:hover {
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.focus\\:border-down\\/60:focus {
  border-color: oklch(var(--down) / 0.6);
}
.focus\\:border-primary:focus {
  --tw-border-opacity: 1;
  border-color: oklch(var(--primary) / var(--tw-border-opacity, 1));
}
.focus\\:border-primary\\/50:focus {
  border-color: oklch(var(--primary) / 0.5);
}
.focus\\:bg-accent:focus {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--accent) / var(--tw-bg-opacity, 1));
}
.focus\\:bg-primary:focus {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--primary) / var(--tw-bg-opacity, 1));
}
.focus\\:text-accent-foreground:focus {
  --tw-text-opacity: 1;
  color: oklch(var(--accent-foreground) / var(--tw-text-opacity, 1));
}
.focus\\:text-primary-foreground:focus {
  --tw-text-opacity: 1;
  color: oklch(var(--primary-foreground) / var(--tw-text-opacity, 1));
}
.focus\\:opacity-100:focus {
  opacity: 1;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-cm-blue\\/10:focus {
  --tw-ring-color: oklch(var(--primary) / 0.1);
}
.focus\\:ring-primary\\/25:focus {
  --tw-ring-color: oklch(var(--primary) / 0.25);
}
.focus\\:ring-primary\\/30:focus {
  --tw-ring-color: oklch(var(--primary) / 0.3);
}
.focus\\:ring-red-400\\/10:focus {
  --tw-ring-color: rgb(248 113 113 / 0.1);
}
.focus\\:ring-ring:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: oklch(var(--ring) / var(--tw-ring-opacity, 1));
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: oklch(var(--ring) / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-offset-1:focus-visible {
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: oklch(var(--background) / 1);
}
.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.99\\]:active {
  --tw-scale-x: 0.99;
  --tw-scale-y: 0.99;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:bg-surface-2:disabled {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--surface-2) / var(--tw-bg-opacity, 1));
}
.disabled\\:text-muted-foreground:disabled {
  --tw-text-opacity: 1;
  color: oklch(var(--muted-foreground) / var(--tw-text-opacity, 1));
}
.disabled\\:no-underline:disabled {
  text-decoration-line: none;
}
.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.group\\/btn:hover .group-hover\\/btn\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group\\/btn:hover .group-hover\\/btn\\:translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-\\[1\\.03\\] {
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.group:hover .group-hover\\:bg-primary\\/20 {
  background-color: oklch(var(--primary) / 0.2);
}
.group:hover .group-hover\\:text-primary {
  --tw-text-opacity: 1;
  color: oklch(var(--primary) / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40 {
  border-color: oklch(var(--muted) / 0.4);
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border {
  --tw-border-opacity: 1;
  border-color: oklch(var(--border) / var(--tw-border-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--muted) / var(--tw-bg-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--primary) / var(--tw-bg-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-background {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--background) / var(--tw-bg-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground {
  --tw-text-opacity: 1;
  color: oklch(var(--muted-foreground) / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground {
  --tw-text-opacity: 1;
  color: oklch(var(--primary-foreground) / var(--tw-text-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-foreground {
  --tw-text-opacity: 1;
  color: oklch(var(--foreground) / var(--tw-text-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover {
  border-color: oklch(var(--down) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--down) / var(--tw-bg-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover {
  --tw-text-opacity: 1;
  color: oklch(var(--foreground) / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover {
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: oklch(var(--down) / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus {
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70 {
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled) {
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--accent) / var(--tw-bg-opacity, 1));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"] {
  background-color: oklch(var(--accent) / 0.5);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"] {
  --tw-text-opacity: 1;
  color: oklch(var(--accent-foreground) / var(--tw-text-opacity, 1));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"] {
  --tw-text-opacity: 1;
  color: oklch(var(--muted-foreground) / var(--tw-text-opacity, 1));
}
.aria-selected\\:opacity-100[aria-selected="true"] {
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"] {
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"] {
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"] {
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"] {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"] {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"] {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"] {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"] {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"] {
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"] {
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up {

  from {
    height: var(--radix-accordion-content-height);
  }

  to {
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"] {
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down {

  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"] {
  animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"] {
  flex-direction: column;
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--accent) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"] {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--background) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"] {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--primary) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"] {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--accent) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"] {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--accent) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"] {
  background-color: oklch(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"] {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--secondary) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"] {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--muted) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"] {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--input) / var(--tw-bg-opacity, 1));
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder] {
  --tw-text-opacity: 1;
  color: oklch(var(--muted-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"] {
  --tw-text-opacity: 1;
  color: oklch(var(--accent-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"] {
  --tw-text-opacity: 1;
  color: oklch(var(--foreground) / var(--tw-text-opacity, 1));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"] {
  --tw-text-opacity: 1;
  color: oklch(var(--primary-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"] {
  --tw-text-opacity: 1;
  color: oklch(var(--accent-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"] {
  --tw-text-opacity: 1;
  color: oklch(var(--accent-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"] {
  --tw-text-opacity: 1;
  color: oklch(var(--muted-foreground) / var(--tw-text-opacity, 1));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"] {
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"] {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"] {
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"] {
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"] {
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"] {
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"] {
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"] {
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"] {
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"] {
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"] {
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"] {
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"] {
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"] {
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"] {
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"] {
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"] {
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"] {
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"] {
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"] {
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"] {
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"] {
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"] {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--accent) / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"] {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--accent) / var(--tw-bg-opacity, 1));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.dark\\:border-destructive:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: oklch(var(--down) / var(--tw-border-opacity, 1));
}
@media (min-width: 640px) {

  .sm\\:bottom-0 {
    bottom: 0px;
  }

  .sm\\:left-auto {
    left: auto;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:right-4 {
    right: 1rem;
  }

  .sm\\:top-auto {
    top: auto;
  }

  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-10 {
    margin-top: 2.5rem;
  }

  .sm\\:mt-12 {
    margin-top: 3rem;
  }

  .sm\\:mt-4 {
    margin-top: 1rem;
  }

  .sm\\:mt-5 {
    margin-top: 1.25rem;
  }

  .sm\\:mt-6 {
    margin-top: 1.5rem;
  }

  .sm\\:mt-7 {
    margin-top: 1.75rem;
  }

  .sm\\:mt-8 {
    margin-top: 2rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:inline-flex {
    display: inline-flex;
  }

  .sm\\:table-cell {
    display: table-cell;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-12 {
    height: 3rem;
  }

  .sm\\:h-16 {
    height: 4rem;
  }

  .sm\\:h-32 {
    height: 8rem;
  }

  .sm\\:h-52 {
    height: 13rem;
  }

  .sm\\:max-h-\\[200px\\] {
    max-height: 200px;
  }

  .sm\\:w-12 {
    width: 3rem;
  }

  .sm\\:w-32 {
    width: 8rem;
  }

  .sm\\:w-48 {
    width: 12rem;
  }

  .sm\\:w-64 {
    width: 16rem;
  }

  .sm\\:w-72 {
    width: 18rem;
  }

  .sm\\:w-\\[22rem\\] {
    width: 22rem;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-fit {
    width: fit-content;
  }

  .sm\\:min-w-\\[58px\\] {
    min-width: 58px;
  }

  .sm\\:min-w-\\[68px\\] {
    min-width: 68px;
  }

  .sm\\:max-w-2xl {
    max-width: 42rem;
  }

  .sm\\:max-w-none {
    max-width: none;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:max-w-xs {
    max-width: 20rem;
  }

  .sm\\:flex-none {
    flex: none;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[1\\.3fr_1fr_auto\\] {
    grid-template-columns: 1.3fr 1fr auto;
  }

  .sm\\:grid-cols-\\[1\\.4fr_1fr_1fr\\] {
    grid-template-columns: 1.4fr 1fr 1fr;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-2xl {
    border-radius: 1rem;
  }

  .sm\\:rounded-lg {
    border-radius: var(--radius);
  }

  .sm\\:border {
    border-width: 1px;
  }

  .sm\\:border-0 {
    border-width: 0px;
  }

  .sm\\:border-border {
    --tw-border-opacity: 1;
    border-color: oklch(var(--border) / var(--tw-border-opacity, 1));
  }

  .sm\\:bg-surface-2 {
    --tw-bg-opacity: 1;
    background-color: oklch(var(--surface-2) / var(--tw-bg-opacity, 1));
  }

  .sm\\:bg-white\\/10 {
    background-color: rgb(255 255 255 / 0.1);
  }

  .sm\\:bg-\\[linear-gradient\\(105deg\\2c oklch\\(0\\.12_0\\.03_160_\\/_0\\.84\\)_0\\%\\2c oklch\\(0\\.12_0\\.03_160_\\/_0\\.42\\)_48\\%\\2c oklch\\(0\\.12_0\\.03_160_\\/_0\\.1\\)_100\\%\\)\\] {
    background-image: linear-gradient(105deg,oklch(0.12 0.03 160 / 0.84) 0%,oklch(0.12 0.03 160 / 0.42) 48%,oklch(0.12 0.03 160 / 0.1) 100%);
  }

  .sm\\:bg-\\[linear-gradient\\(to_top\\2c oklch\\(0\\.12_0\\.03_160_\\/_0\\.45\\)_0\\%\\2c oklch\\(0\\.12_0\\.03_160_\\/_0\\.1\\)_38\\%\\2c transparent_70\\%\\)\\] {
    background-image: linear-gradient(to top,oklch(0.12 0.03 160 / 0.45) 0%,oklch(0.12 0.03 160 / 0.1) 38%,transparent 70%);
  }

  .sm\\:object-\\[80\\%_70\\%\\] {
    object-position: 80% 70%;
  }

  .sm\\:p-1 {
    padding: 0.25rem;
  }

  .sm\\:p-12 {
    padding: 3rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-7 {
    padding: 1.75rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-16 {
    padding-bottom: 4rem;
  }

  .sm\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .sm\\:pl-7 {
    padding-left: 1.75rem;
  }

  .sm\\:pr-3 {
    padding-right: 0.75rem;
  }

  .sm\\:pt-12 {
    padding-top: 3rem;
  }

  .sm\\:pt-16 {
    padding-top: 4rem;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .sm\\:text-\\[15px\\] {
    font-size: 15px;
  }

  .sm\\:text-\\[28px\\] {
    font-size: 28px;
  }

  .sm\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .sm\\:text-\\[44px\\] {
    font-size: 44px;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:leading-7 {
    line-height: 1.75rem;
  }

  .sm\\:opacity-45 {
    opacity: 0.45;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"] {
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px) {

  .md\\:absolute {
    position: absolute;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:inline-flex {
    display: inline-flex;
  }

  .md\\:table-cell {
    display: table-cell;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\] {
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:max-w-\\[420px\\] {
    max-width: 420px;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[1\\.4fr_repeat\\(3\\2c 1fr\\)\\] {
    grid-template-columns: 1.4fr repeat(3,1fr);
  }

  .md\\:grid-cols-\\[160px_1fr_1fr_auto\\] {
    grid-template-columns: 160px 1fr 1fr auto;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:right-12 {
    right: 3rem;
  }

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:mb-12 {
    margin-bottom: 3rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:table-cell {
    display: table-cell;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-14 {
    height: 3.5rem;
  }

  .lg\\:max-h-none {
    max-height: none;
  }

  .lg\\:min-h-\\[180px\\] {
    min-height: 180px;
  }

  .lg\\:min-h-\\[340px\\] {
    min-height: 340px;
  }

  .lg\\:w-14 {
    width: 3.5rem;
  }

  .lg\\:min-w-\\[860px\\] {
    min-width: 860px;
  }

  .lg\\:max-w-3xl {
    max-width: 48rem;
  }

  .lg\\:max-w-\\[680px\\] {
    max-width: 680px;
  }

  .lg\\:flex-1 {
    flex: 1 1;
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[0\\.95fr_1\\.05fr\\] {
    grid-template-columns: 0.95fr 1.05fr;
  }

  .lg\\:grid-cols-\\[1\\.2fr_1fr\\] {
    grid-template-columns: 1.2fr 1fr;
  }

  .lg\\:grid-cols-\\[1\\.4fr\\2c 1fr\\] {
    grid-template-columns: 1.4fr 1fr;
  }

  .lg\\:grid-cols-\\[1\\.4fr_1fr\\] {
    grid-template-columns: 1.4fr 1fr;
  }

  .lg\\:grid-cols-\\[1fr\\2c 360px\\] {
    grid-template-columns: 1fr 360px;
  }

  .lg\\:grid-cols-\\[1fr\\2c 400px\\] {
    grid-template-columns: 1fr 400px;
  }

  .lg\\:grid-cols-\\[1fr_1\\.15fr\\] {
    grid-template-columns: 1fr 1.15fr;
  }

  .lg\\:grid-cols-\\[1fr_1\\.3fr\\] {
    grid-template-columns: 1fr 1.3fr;
  }

  .lg\\:grid-cols-\\[1fr_1\\.4fr\\] {
    grid-template-columns: 1fr 1.4fr;
  }

  .lg\\:grid-cols-\\[1fr_280px\\] {
    grid-template-columns: 1fr 280px;
  }

  .lg\\:grid-cols-\\[1fr_300px\\] {
    grid-template-columns: 1fr 300px;
  }

  .lg\\:grid-cols-\\[1fr_360px\\] {
    grid-template-columns: 1fr 360px;
  }

  .lg\\:grid-cols-\\[1fr_auto\\] {
    grid-template-columns: 1fr auto;
  }

  .lg\\:grid-cols-\\[220px_1fr\\] {
    grid-template-columns: 220px 1fr;
  }

  .lg\\:grid-cols-\\[250px_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 250px minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[28px_1\\.6fr_1fr_120px_1fr_1fr_90px\\] {
    grid-template-columns: 28px 1.6fr 1fr 120px 1fr 1fr 90px;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:items-stretch {
    align-items: stretch;
  }

  .lg\\:gap-1 {
    gap: 0.25rem;
  }

  .lg\\:gap-1\\.5 {
    gap: 0.375rem;
  }

  .lg\\:gap-14 {
    gap: 3.5rem;
  }

  .lg\\:gap-16 {
    gap: 4rem;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .lg\\:border-r {
    border-right-width: 1px;
  }

  .lg\\:object-\\[72\\%_100\\%\\] {
    object-position: 72% 100%;
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .lg\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .lg\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .lg\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:pb-16 {
    padding-bottom: 4rem;
  }

  .lg\\:pb-24 {
    padding-bottom: 6rem;
  }

  .lg\\:pt-14 {
    padding-top: 3.5rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .lg\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .lg\\:text-\\[1\\.75rem\\] {
    font-size: 1.75rem;
  }

  .lg\\:text-\\[17px\\] {
    font-size: 17px;
  }

  .lg\\:text-\\[2\\.75rem\\] {
    font-size: 2.75rem;
  }

  .lg\\:text-\\[26px\\] {
    font-size: 26px;
  }

  .lg\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .lg\\:text-\\[52px\\] {
    font-size: 52px;
  }

  .lg\\:leading-\\[1\\.15\\] {
    line-height: 1.15;
  }

  .lg\\:leading-\\[1\\.35\\] {
    line-height: 1.35;
  }
}
@media (min-width: 1280px) {

  .xl\\:right-16 {
    right: 4rem;
  }

  .xl\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .xl\\:h-0 {
    height: 0px;
  }

  .xl\\:max-h-none {
    max-height: none;
  }

  .xl\\:min-h-full {
    min-height: 100%;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[230px_minmax\\(0\\2c 1fr\\)_290px\\] {
    grid-template-columns: 230px minmax(0,1fr) 290px;
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:items-center {
    align-items: center;
  }

  .xl\\:border-r {
    border-right-width: 1px;
  }

  .xl\\:border-border {
    --tw-border-opacity: 1;
    border-color: oklch(var(--border) / var(--tw-border-opacity, 1));
  }

  .xl\\:pr-6 {
    padding-right: 1.5rem;
  }
}
@media print {

  .print\\:hidden {
    display: none;
  }
}
.\\[\\&\\+div\\]\\:text-xs+div {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end) {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start) {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]) {
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]) {
  --tw-bg-opacity: 1;
  background-color: oklch(var(--accent) / var(--tw-bg-opacity, 1));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside) {
  background-color: oklch(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end) {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]) {
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox] {
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div {
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg {
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg {
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg {
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg {
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg {
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg {
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg {
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg {
  --tw-text-opacity: 1;
  color: oklch(var(--down) / var(--tw-text-opacity, 1));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg {
  --tw-text-opacity: 1;
  color: oklch(var(--foreground) / var(--tw-text-opacity, 1));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~* {
  padding-left: 1.75rem;
}
.\\[\\&\\>td\\]\\:px-3>td {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.\\[\\&\\>th\\]\\:px-3>th {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.\\[\\&\\>th\\]\\:py-2\\.5>th {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr {
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading] {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading] {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading] {
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading] {
  --tw-text-opacity: 1;
  color: oklch(var(--muted-foreground) / var(--tw-text-opacity, 1));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group] {
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg {
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg {
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input] {
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item] {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg {
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg {
  width: 1.25rem;
}
.\\[\\&_p\\]\\:leading-relaxed p {
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg {
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg {
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg {
  flex-shrink: 0;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child {
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr {
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,uDAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,0EAAmB;EAAnB;AAAmB;AAAnB;EAAA,iFAAmB;EAAnB,6EAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;;;uEAIuE;AACvE;;EAEE,kBAAkB;EAClB,gBAAgB;;EAEhB,gCAAgC;EAChC,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;;EAE5B,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;EACzB,mCAAmC;EACnC,wBAAwB;EACxB,6BAA6B;EAC7B,qCAAqC;EACrC,2BAA2B;EAC3B,qCAAqC;EACrC,uBAAuB;EACvB,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,qBAAqB;;EAErB,gGAAgG;EAChG,sCAAsC;EACtC,4DAA4D;EAC5D,4DAA4D;EAC5D,4DAA4D;EAC5D,yGAAyG;EACzG,2CAA2C;;EAE3C,6DAA6D;EAC7D,gCAAgC;EAChC,0CAA0C;EAC1C,2CAA2C;EAC3C,sCAAsC;EACtC,mCAAmC;EACnC,yCAAyC;EACzC,kCAAkC;EAClC,sCAAsC;EACtC,wCAAwC;EACxC,qCAAqC;EACrC,gCAAgC;EAChC,iCAAiC;EACjC,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;EAC1B,mCAAmC;EACnC,wBAAwB;EACxB,8BAA8B;EAC9B,mCAAmC;EACnC,0BAA0B;EAC1B,sCAAsC;EACtC,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,qBAAqB;;EAErB,qFAAqF;EACrF,oFAAoF;EACpF,6DAA6D;EAC7D,2DAA2D;EAC3D,8FAA8F;EAC9F,uGAAuG;EACvG,kCAAkC;AACpC;;AAgCA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,+BAA+B;EAC/B,yDAAyD;EACzD,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;;mGAEiG;AACnG;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;;;EAGE,oEAAoE;EACpE,mDAAmD;EACnD,6BAA6B;AAC/B;;AAEA,wEAAwE;AACxE;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA,0DAA0D;AAC1D;EACE,2DAA2D;AAC7D;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,sDAAsD;EACtD,wDAAwD;AAC1D;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC;;;;6CAI2C;AAC7C;;AAEA;EACE;IACE,mBAAmB;IACnB;;;;+CAI2C;EAC7C;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,uDAAuD;EACvD,yDAAyD;EACzD,WAAW;AACb;;AAEA;EACE;IACE,uDAAuD;IACvD,yDAAyD;EAC3D;AACF;;AAEA;EACE,gBAAgB,kBAAkB,EAAE,mBAAmB,EAAE;AAC3D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,uCAAuC;EACvC,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,0EAA0E;EAC1E,+BAA+B;EAC/B,eAAe;EACf,SAAS;AACX;AACA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;AACA,yBAAyB,sBAAsB,EAAE;;AAEjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,0BAA0B;EAC1B,6CAA6C;EAC7C,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB,eAAe,EAAE;AACvC;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;AACA,YAAY,2CAA2C,EAAE;;AAEzD;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;AACA,gBAAgB,2CAA2C,EAAE;AAC7D,mBAAmB,mDAAmD,EAAE;AACxE,gBAAgB,2CAA2C,EAAE;;AAE7D;EACE,WAAW,mBAAmB,EAAE,YAAY,EAAE,gDAAgD,EAAE;EAChG,MAAM,sBAAsB,EAAE,UAAU,EAAE,qDAAqD,EAAE;AACnG;AACA,kBAAkB,mDAAmD,EAAE;;AAEvE;EACE,WAAW,mBAAmB,EAAE,aAAa,EAAE;EAC/C,MAAM,sBAAsB,EAAE,aAAa,EAAE;AAC/C;AACA,mBAAmB,kDAAkD,EAAE,wBAAwB,EAAE;AACjG,wBAAwB,kDAAkD,EAAE,wBAAwB,EAAE,qBAAqB,EAAE;;AAE7H;EACE,OAAO,wBAAwB,EAAE;EACjC,KAAK,2BAA2B,EAAE;AACpC;AACA;EACE,yCAAyC;EACzC,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB,eAAe,EAAE;AACvC;;AAEA,sCAAsC,aAAa,EAAE;AACrD,mBAAmB,wBAAwB,EAAE,qBAAqB,EAAE;;AAEpE,yCAAyC;AACzC;EACE,UAAU;EACV,+CAA+C;EAC/C,0DAA0D;EAC1D,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,eAAe;EACf,wCAAwC;AAC1C;;AAEA,4BAA4B,kCAAkC,EAAE;AAChE,4BAA4B,+BAA+B,EAAE;AAC7D,4BAA4B,mCAAmC,EAAE;AACjE,4BAA4B,kCAAkC,EAAE;AAChE,4BAA4B,sBAAsB,EAAE;;AAEpD;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA;EACE;6DAC2D;EAC3D,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;AACA;EACE,qFAAqF;EACrF,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,WAAW,6CAA6C,EAAE,YAAY,EAAE;EACxE,WAAW,qDAAqD,EAAE,UAAU,EAAE;AAChF;AACA,mBAAmB,oDAAoD,EAAE;;AAEzE;EACE,OAAO,UAAU,EAAE,4DAA4D,EAAE;EACjF,OAAO,UAAU,EAAE,sDAAsD,EAAE;AAC7E;AACA,cAAc,8DAA8D,EAAE;;AAE9E,2DAA2D;AAC3D;EACE;;;sBAGoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,sCAAsC;EACtC,sBAAsB;EACtB,uCAAuC;EACvC,iIAAiI;EACjI,8BAA8B;EAC9B,gFAAgF;AAClF;AACA;;EAEE,0CAA0C;EAC1C,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE;;4EAE0E;EAC1E,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE;;gFAE8E;AAChF;;AAEA;;uEAEuE;AACvE,gBAAgB,oCAAoC,EAAE;;AAEtD,kBAAkB,uCAAuC,EAAE;AAC3D;EACE,0FAA0F;AAC5F;AACA;EACE,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,iIAAiI;AACnI;;AAEA;;EAEE;;;;;GAKC;AACH;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,iIAAiI;EACjI,8BAA8B;EAC9B;;;yBAGuB;EACvB,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,kFAAkF;EAClF;;;;;GAKC;EACD,oCAAoC;AACtC;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,8GAA8G;EAC9G,6EAA6E;AAC/E;AACA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;EACA;;;IAGE,eAAe;EACjB;AACF;;AAEA,gBAAgB,+BAA+B,EAAE;;AAEjD;EACE;;gFAE8E;EAC9E,0BAA0B;EAC1B,6EAA6E;AAC/E;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;AACA,iBAAiB,uCAAuC,EAAE;AAC1D,8BAA8B,sBAAsB,EAAE;AACtD,8BAA8B,sBAAsB,EAAE;AACtD,8BAA8B,qBAAqB,EAAE;AACrD,8BAA8B,sBAAsB,EAAE;AACtD,8BAA8B,sBAAsB,EAAE;;AAEtD,cAAc,qDAAqD,EAAE;AACrE;EACE,cAAc,qDAAqD,EAAE;AACvE;AACA;EACE,iBAAiB,eAAe,EAAE;AACpC;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;EAC7C,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;AACA,aAAa,sCAAsC,EAAE;;AAErD;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;EAClC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;AACA,iBAAiB,mCAAmC,EAAE;;AAEtD;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,2BAA2B,EAAE;AACpC;AACA;EACE,kBAAkB;EAClB,wIAAwI;EACxI,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mDAAmD;EACnD,uCAAuC;AACzC;AACA,sBAAsB,+CAA+C,EAAE;;AAEvE;EACE;;gFAE8E;EAC9E,0BAA0B;AAC5B;AACA;EACE;;iFAE+E;EAC/E,0BAA0B;AAC5B;;AAEA,sBAAsB,KAAK,yCAAyC,EAAE,EAAE,OAAO,6BAA6B,EAAE,EAAE;AAChH,wBAAwB,KAAK,2CAA2C,EAAE,EAAE,OAAO,6BAA6B,EAAE,EAAE;AACpH;EACE,KAAK,+CAA+C,EAAE;EACtD,MAAM,6CAA6C,EAAE;EACrD,OAAO,+CAA+C,EAAE;AAC1D;AACA,uBAAuB,OAAO,wBAAwB,EAAE,EAAE,KAAK,2BAA2B,EAAE,EAAE;AAC9F,mBAAmB,UAAU,yBAAyB,EAAE,MAAM,6BAA6B,EAAE;AAC7F,YAAY,iCAAiC,EAAE;AAC/C,cAAc,mCAAmC,EAAE;AACnD,gBAAgB,8CAA8C,EAAE;AAChE,mBAAmB,wCAAwC,EAAE;AAC7D;EACE,8DAA8D,eAAe,EAAE;AACjF;;AAEA,eAAe,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACtE,gBAAgB,kBAAkB,EAAE,eAAe,EAAE;;AAErD,oBAAoB,uBAAuB,EAAE;AAC7C,qBAAqB,aAAa,EAAE;AACpC,2BAA2B,aAAa,EAAE;AAC1C,4BAA4B,cAAc,EAAE,sBAAsB,EAAE;;AAEpE,4CAA4C;AAC5C;EACE,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE;;;;;GAKC;AACH;AACA;EACE,uCAAuC;EACvC,iCAAiC;AACnC;AACA;EACE,mCAAmC;EACnC,kDAAkD;AACpD;AACA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,gDAAgD;AAClD;AACA;EACE,yFAAyF;EACzF,kCAAkC;AACpC;AACA;EACE,8CAA8C;EAC9C,sFAAsF;AACxF;;AAEA,mDAAmD;AACnD;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;AACA;;EAEE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,qCAAqC;AACvC;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;;EAEE,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,+BAA+B;AACjC;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;;EAEE,iBAAiB;AACnB;AACA;;;;EAIE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;EAEE,4CAA4C;EAC5C,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,kBAAkB;AACpB;AACA;;EAEE,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;AACnB;AACA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AA57BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,mBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA,QA67BA;EA77BA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA,sBA67BA;EA77BA;AA67BA;AA77BA;EAAA,iDA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kDA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,sBA67BA;EA77BA;AA67BA;AA77BA;EAAA,2BA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,sBA67BA;EA77BA;AA67BA;AA77BA;EAAA,sBA67BA;EA77BA;AA67BA;AA77BA;EAAA,sBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,+BA67BA;EA77BA,uCA67BA;EA77BA;AA67BA;AA77BA;EAAA,qCA67BA;EA77BA,6CA67BA;EA77BA;AA67BA;AA77BA;EAAA,6EA67BA;EA77BA,iGA67BA;EA77BA;AA67BA;AA77BA;EAAA,0CA67BA;EA77BA,uDA67BA;EA77BA;AA67BA;AA77BA;EAAA,yCA67BA;EA77BA;AA67BA;AA77BA;EAAA,2GA67BA;EA77BA,yGA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,gCA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,sBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,8BA67BA;EA77BA;AA67BA;AA77BA;EAAA,2GA67BA;EA77BA,yGA67BA;EA77BA;AA67BA;AA77BA;EAAA,2GA67BA;EA77BA,yGA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,8BA67BA;EA77BA;AA67BA;AA77BA;EAAA,2GA67BA;EA77BA,yGA67BA;EA77BA;AA67BA;AA77BA;EAAA,2GA67BA;EA77BA,yGA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,iBA67BA;EA77BA,iBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,yBA67BA;EA77BA;AA67BA;AA77BA;EAAA,sBA67BA;EA77BA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,sBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,+EA67BA;EA77BA,mGA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,yBA67BA;EA77BA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA;AA67BA;AA77BA;EAAA,yBA67BA;EA77BA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA;AA67BA;AA77BA;EAAA,sBA67BA;EA77BA;AA67BA;AA77BA;EAAA,qBA67BA;EA77BA;AA67BA;AA77BA;EAAA,qBA67BA;EA77BA;AA67BA;AA77BA;EAAA,gDA67BA;EA77BA;AA67BA;AA77BA;EAAA,iDA67BA;EA77BA;AA67BA;AA77BA;;EAAA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;AAAA;AA77BA;EAAA;AA67BA;AA77BA;;EAAA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;AAAA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,0EA67BA;EA77BA,8FA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,qBA67BA;EA77BA,yBA67BA;EA77BA,2BA67BA;EA77BA,yBA67BA;EA77BA,0BA67BA;EA77BA,+BA67BA;EA77BA;AA67BA;AA77BA;EAAA,qBA67BA;EA77BA,yBA67BA;EA77BA,2BA67BA;EA77BA,yBA67BA;EA77BA,0BA67BA;EA77BA,+BA67BA;EA77BA;AA67BA;AA77BA;EAAA,qBA67BA;EA77BA,yBA67BA;EA77BA,2BA67BA;EA77BA,yBA67BA;EA77BA,0BA67BA;EA77BA,+BA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA,yBA67BA;EA77BA,0BA67BA;EA77BA,wBA67BA;EA77BA,yBA67BA;EA77BA,8BA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA,yBA67BA;EA77BA,0BA67BA;EA77BA,wBA67BA;EA77BA,yBA67BA;EA77BA,8BA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA,yBA67BA;EA77BA,0BA67BA;EA77BA,wBA67BA;EA77BA,yBA67BA;EA77BA,8BA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA,yBA67BA;EA77BA,0BA67BA;EA77BA,wBA67BA;EA77BA,yBA67BA;EA77BA,8BA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA,sBA67BA;EA77BA;AA67BA;AA77BA;EAAA,0BA67BA;EA77BA,qBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,mBA67BA;EA77BA;AA67BA;AA77BA;EAAA,sBA67BA;EA77BA;AA67BA;AA77BA;;EAAA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA,uBA67BA;IA77BA,sDA67BA;IA77BA;EA67BA;;EA77BA;IAAA,uBA67BA;IA77BA,oDA67BA;IA77BA;EA67BA;;EA77BA;IAAA,uBA67BA;IA77BA,2DA67BA;IA77BA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA,sBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,kBA67BA;IA77BA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA,kBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,oBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,kBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,oBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,qBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,kBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,mBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,iBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,iBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,iBA67BA;IA77BA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA,iBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,mBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,kBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,eA67BA;IA77BA;EA67BA;;EA77BA;IAAA,kBA67BA;IA77BA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA,eA67BA;IA77BA;EA67BA;;EA77BA;IAAA,mBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,mBA67BA;IA77BA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;AAAA;AA77BA;;EAAA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA,kBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,mBA67BA;IA77BA;EA67BA;AAAA;AA77BA;;EAAA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA,qBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,qBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,kBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,mBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,iBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,iBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,iBA67BA;IA77BA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA,eA67BA;IA77BA;EA67BA;;EA77BA;IAAA,kBA67BA;IA77BA;EA67BA;;EA77BA;IAAA,iBA67BA;IA77BA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;AAAA;AA77BA;;EAAA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA;EA67BA;;EA77BA;IAAA,sBA67BA;IA77BA;EA67BA;;EA77BA;IAAA;EA67BA;AAAA;AA77BA;;EAAA;IAAA;EA67BA;AAAA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kDA67BA;EA77BA;AA67BA;AA77BA;EAAA,iDA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,iDA67BA;EA77BA;AA67BA;AA77BA;EAAA,kDA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kDA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,qBA67BA;EA77BA;AA67BA;AA77BA;EAAA,gBA67BA;EA77BA,oBA67BA;EA77BA,4BA67BA;EA77BA;AA67BA;AA77BA;EAAA,sBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,WA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,qBA67BA;EA77BA;AA67BA;AA77BA;EAAA,qBA67BA;EA77BA;AA67BA;AA77BA;EAAA,qBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA,mBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,qBA67BA;EA77BA;AA67BA;AA77BA;EAAA,kBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA,oBA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA,WA67BA;EA77BA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA;AA77BA;EAAA;AA67BA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* ------------------------------------------------------------------ *\n * PaisaCX design tokens. Channels are \"r g b\" so Tailwind opacity     *\n * modifiers (bg-primary/10) work. Dark is the default theme; the      *\n * `.light` class on <html> switches to the mint light theme.          *\n * ------------------------------------------------------------------ */\n:root,\n.dark {\n  color-scheme: dark;\n  --radius: 0.5rem;\n\n  --brand-emerald: 0.668 0.142 164;\n  --brand-green: 0.787 0.212 147;\n  --brand-lime: 0.821 0.242 141;\n  --brand-teal: 0.415 0.069 207;\n  --brand-ink: 0.183 0.023 249;\n\n  --background: 0.13 0.016 245;\n  --foreground: 0.94 0.01 210;\n  --surface: 0.175 0.02 240;\n  --surface-2: 0.225 0.024 235;\n  --page: 0.148 0.0176 242;\n  --card: 0.175 0.02 240;\n  --card-foreground: 0.94 0.01 210;\n  --popover: 0.21 0.024 235;\n  --popover-foreground: 0.94 0.01 210;\n  --primary: 0.74 0.18 153;\n  --primary-deep: 0.66 0.17 153;\n  --primary-foreground: 0.183 0.023 249;\n  --secondary: 0.26 0.028 230;\n  --secondary-foreground: 0.94 0.01 210;\n  --muted: 0.26 0.028 230;\n  --muted-foreground: 0.68 0.024 220;\n  --dim: 0.55 0.022 220;\n  --accent: 0.415 0.069 207;\n  --accent-foreground: 0.96 0.01 190;\n  --up: 0.76 0.2 146;\n  --down: 0.65 0.21 18;\n  --warning: 0.8 0.15 85;\n  --border: 0.28 0.028 230;\n  --line-strong: 0.34 0.03 230;\n  --input: 0.225 0.024 235;\n  --ring: 0.74 0.18 153;\n\n  --gradient-brand: linear-gradient(120deg, oklch(var(--brand-emerald)), oklch(var(--brand-lime)));\n  --gradient-text: var(--gradient-brand);\n  --shadow-panel: 0 24px 60px -30px oklch(0.06 0.03 240 / 0.9);\n  --shadow-brand: 0 18px 44px -18px oklch(0.74 0.18 153 / 0.6);\n  --shadow-card: 0 12px 32px -20px oklch(0.06 0.03 240 / 0.85);\n  --shadow-card-hover: 0 20px 44px -18px oklch(0.06 0.03 240 / 0.9), 0 0 0 1px oklch(var(--primary) / 0.28);\n  --table-head: oklch(var(--surface-2) / 0.4);\n\n  /* Legacy PaisaCX variables, pointed at the PaisaCX palette */\n  --cm-blue: oklch(var(--primary));\n  --cm-blue-deep: oklch(var(--primary-deep));\n  --cm-blue-hover: oklch(var(--primary-deep));\n  --cm-blue-vivid: oklch(var(--primary));\n  --cm-navy: oklch(var(--foreground));\n  --cm-grey: oklch(var(--muted-foreground));\n  --cm-orange: oklch(var(--warning));\n  --cm-lavender: oklch(var(--surface-2));\n  --cm-lavender-2: oklch(var(--surface-2));\n  --cm-card-soft: oklch(var(--surface));\n  --cm-surface: oklch(var(--page));\n  --cm-border: oklch(var(--border));\n  --cm-green: oklch(var(--up));\n  --cm-red: oklch(var(--down));\n}\n\n.light {\n  color-scheme: light;\n  --background: 0.945 0.028 158;\n  --foreground: 0.22 0.04 165;\n  --surface: 0.975 0.02 152;\n  --surface-2: 0.915 0.035 156;\n  --page: 0.957 0.0248 155.6;\n  --card: 0.975 0.02 152;\n  --card-foreground: 0.22 0.04 165;\n  --popover: 0.985 0.016 150;\n  --popover-foreground: 0.22 0.04 165;\n  --primary: 0.5 0.135 158;\n  --primary-deep: 0.44 0.125 158;\n  --primary-foreground: 0.18 0.03 165;\n  --secondary: 0.91 0.04 162;\n  --secondary-foreground: 0.24 0.045 165;\n  --muted: 0.91 0.032 158;\n  --muted-foreground: 0.42 0.04 170;\n  --dim: 0.55 0.035 168;\n  --accent: 0.9 0.055 165;\n  --accent-foreground: 0.28 0.06 168;\n  --up: 0.5 0.15 150;\n  --down: 0.55 0.2 22;\n  --warning: 0.64 0.14 75;\n  --border: 0.84 0.045 158;\n  --line-strong: 0.78 0.05 158;\n  --input: 0.86 0.04 156;\n  --ring: 0.5 0.135 158;\n\n  --gradient-brand: linear-gradient(120deg, oklch(0.55 0.145 163), oklch(0.72 0.2 145));\n  --gradient-text: linear-gradient(120deg, oklch(0.42 0.12 166), oklch(0.52 0.16 148));\n  --shadow-panel: 0 22px 48px -26px oklch(0.42 0.08 160 / 0.28);\n  --shadow-brand: 0 14px 34px -14px oklch(0.5 0.14 158 / 0.4);\n  --shadow-card: 0 1px 0 oklch(0.55 0.1 160 / 0.1), 0 12px 30px -16px oklch(0.4 0.08 160 / 0.22);\n  --shadow-card-hover: 0 1px 0 oklch(0.55 0.12 160 / 0.14), 0 22px 42px -16px oklch(0.48 0.12 158 / 0.28);\n  --table-head: oklch(0.93 0.03 156);\n}\n\n@layer components {\n  .cm-btn-deposit {\n    @apply px-4 py-2 rounded-lg text-[13px] font-semibold inline-flex items-center gap-2;\n    background-image: var(--gradient-brand);\n    color: oklch(var(--brand-ink));\n  }\n  .cm-btn-deposit:hover,\n  .cm-btn-deposit:active,\n  .cm-btn-deposit:focus-visible {\n    filter: brightness(1.08);\n    color: oklch(var(--brand-ink));\n  }\n\n  .trade-scroll {\n    scrollbar-width: thin;\n    scrollbar-color: oklch(var(--line-strong)) transparent;\n  }\n  .trade-scroll::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n  .trade-scroll::-webkit-scrollbar-thumb {\n    background: oklch(var(--line-strong));\n    border-radius: 4px;\n  }\n  .trade-scroll::-webkit-scrollbar-track {\n    background: transparent;\n  }\n}\n\n* {\n  border-color: oklch(var(--border));\n}\n\nhtml {\n  overflow-x: hidden;\n  max-width: 100%;\n}\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  background: oklch(var(--page));\n  color: oklch(var(--foreground));\n  font-family: 'Sora', ui-sans-serif, system-ui, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  overflow-x: hidden;\n  max-width: 100vw;\n  min-height: 100vh;\n  min-height: 100dvh;\n}\n\n.light body {\n  background-image:\n    radial-gradient(ellipse 80% 50% at 10% -10%, oklch(var(--brand-lime) / 0.16), transparent 55%),\n    radial-gradient(ellipse 70% 45% at 95% 0%, oklch(var(--brand-emerald) / 0.14), transparent 50%);\n}\n\n#root {\n  overflow-x: clip;\n  max-width: 100%;\n}\n\nbutton, input, select, textarea {\n  font-family: inherit;\n}\n\nh1, h2, h3, h4 {\n  font-family: 'Sora', ui-sans-serif, system-ui, sans-serif;\n}\n\n.num,\n.tabular-nums,\n[class*=\"tabular-nums\"] {\n  font-family: 'Sora', ui-sans-serif, system-ui, sans-serif !important;\n  font-variant-numeric: lining-nums proportional-nums;\n  font-feature-settings: normal;\n}\n\n/* Inputs follow the theme even when components hardcode light colours */\ninput, select, textarea {\n  color: inherit;\n}\ninput::placeholder, textarea::placeholder {\n  color: oklch(var(--dim));\n}\nselect option {\n  background: oklch(var(--popover));\n  color: oklch(var(--popover-foreground));\n}\n\n/* Safe areas for notched phones / mobile browser chrome */\n.pb-safe {\n  padding-bottom: max(1rem, env(safe-area-inset-bottom, 0px));\n}\n\n.pt-safe {\n  padding-top: max(0px, env(safe-area-inset-top, 0px));\n}\n\n.px-safe {\n  padding-left: max(0px, env(safe-area-inset-left, 0px));\n  padding-right: max(0px, env(safe-area-inset-right, 0px));\n}\n\n/* Shared modal shell — scrollable on small viewports */\n.cm-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  padding:\n    max(12px, env(safe-area-inset-top, 0px))\n    max(12px, env(safe-area-inset-right, 0px))\n    max(12px, env(safe-area-inset-bottom, 0px))\n    max(12px, env(safe-area-inset-left, 0px));\n}\n\n@media (min-width: 640px) {\n  .cm-modal-overlay {\n    align-items: center;\n    padding:\n      max(16px, env(safe-area-inset-top, 0px))\n      max(16px, env(safe-area-inset-right, 0px))\n      max(16px, env(safe-area-inset-bottom, 0px))\n      max(16px, env(safe-area-inset-left, 0px));\n  }\n}\n\n.cm-modal-panel {\n  width: 100%;\n  max-height: none;\n  margin: auto 0;\n}\n\n@media (min-width: 640px) {\n  .cm-modal-panel {\n    max-height: min(92dvh, 100%);\n  }\n}\n\n::selection {\n  background: oklch(var(--primary));\n  color: oklch(var(--primary-foreground));\n}\n\n/* Utility classes */\n.cm-container {\n  max-width: 1280px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: max(16px, env(safe-area-inset-left, 0px));\n  padding-right: max(16px, env(safe-area-inset-right, 0px));\n  width: 100%;\n}\n\n@media (min-width: 640px) {\n  .cm-container {\n    padding-left: max(24px, env(safe-area-inset-left, 0px));\n    padding-right: max(24px, env(safe-area-inset-right, 0px));\n  }\n}\n\n@media (min-width: 1024px) {\n  .cm-container { padding-left: 32px; padding-right: 32px; }\n}\n\n.cm-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 26px;\n  background-image: var(--gradient-brand);\n  color: oklch(var(--brand-ink));\n  font-weight: 600;\n  font-size: 15px;\n  border-radius: var(--radius);\n  transition: filter 200ms ease, transform 200ms ease, box-shadow 200ms ease;\n  box-shadow: var(--shadow-brand);\n  cursor: pointer;\n  border: 0;\n}\n.cm-btn-primary:hover {\n  filter: brightness(1.08) saturate(1.05);\n  transform: translateY(-1px);\n}\n.cm-btn-primary:active { transform: scale(0.98); }\n\n.cm-btn-outline {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 11px 25px;\n  background: oklch(var(--surface-2));\n  color: oklch(var(--foreground));\n  font-weight: 600;\n  font-size: 15px;\n  border-radius: var(--radius);\n  transition: all 200ms ease;\n  border: 1px solid oklch(var(--primary) / 0.4);\n  cursor: pointer;\n}\n.cm-btn-outline:hover {\n  border-color: oklch(var(--primary));\n  background: oklch(var(--primary) / 0.1);\n  color: oklch(var(--primary));\n}\n\n.cm-section-title {\n  font-size: 32px;\n  line-height: 1.15;\n  font-weight: 600;\n  color: oklch(var(--foreground));\n}\n\n@media (min-width: 768px) {\n  .cm-section-title { font-size: 44px; }\n}\n\n.cm-eyebrow {\n  color: oklch(var(--muted-foreground));\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n/* Animations */\n@keyframes cm-float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-12px); }\n}\n.cm-float { animation: cm-float 6s ease-in-out infinite; }\n\n@keyframes cm-fade-up {\n  from { opacity: 0; transform: translateY(24px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n.cm-fade-up {\n  animation: cm-fade-up 700ms ease-out both;\n}\n\n@keyframes cm-spin-slow {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n.cm-spin-slow { animation: cm-spin-slow 40s linear infinite; }\n.cm-spin-reverse { animation: cm-spin-slow 50s linear infinite reverse; }\n.cm-spin-fast { animation: cm-spin-slow 22s linear infinite; }\n\n@keyframes cm-orbit-pulse {\n  0%, 100% { transform: scale(1); opacity: 0.9; box-shadow: 0 0 0 0 oklch(var(--primary) / 0.35); }\n  50% { transform: scale(1.35); opacity: 1; box-shadow: 0 0 18px 4px oklch(var(--primary) / 0.35); }\n}\n.cm-orbit-pulse { animation: cm-orbit-pulse 2.4s ease-in-out infinite; }\n\n@keyframes cm-ring-breathe {\n  0%, 100% { transform: scale(1); opacity: 0.55; }\n  50% { transform: scale(1.03); opacity: 0.95; }\n}\n.cm-ring-breathe { animation: cm-ring-breathe 5s ease-in-out infinite; transform-origin: center; }\n.cm-ring-breathe-slow { animation: cm-ring-breathe 7s ease-in-out infinite; transform-origin: center; animation-delay: 0.6s; }\n\n@keyframes cm-marquee {\n  from { transform: translateX(0); }\n  to { transform: translateX(-50%); }\n}\n.cm-marquee-track {\n  animation: cm-marquee 45s linear infinite;\n  will-change: transform;\n}\n.cm-ticker-marquee {\n  overflow: hidden;\n  contain: layout style;\n}\n.cm-ticker-marquee:hover .cm-marquee-track {\n  animation-play-state: paused;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cm-marquee-track { animation: none; }\n}\n\n.cm-no-scrollbar::-webkit-scrollbar { display: none; }\n.cm-no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }\n\n/* Scroll-triggered entrance animations */\n.cm-reveal {\n  opacity: 0;\n  transition-property: opacity, transform, filter;\n  transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);\n  will-change: opacity, transform;\n  filter: blur(2px);\n}\n.cm-reveal.is-in {\n  opacity: 1;\n  filter: blur(0);\n  transform: translate3d(0, 0, 0) scale(1);\n}\n\n.cm-reveal-fade-up        { transform: translate3d(0, 36px, 0); }\n.cm-reveal-fade           { transform: translate3d(0, 0, 0); }\n.cm-reveal-fade-left      { transform: translate3d(-40px, 0, 0); }\n.cm-reveal-fade-right     { transform: translate3d(40px, 0, 0); }\n.cm-reveal-zoom-soft      { transform: scale(0.96); }\n\n@media (prefers-reduced-motion: reduce) {\n  .cm-reveal, .cm-reveal.is-in {\n    opacity: 1 !important;\n    transform: none !important;\n    filter: none !important;\n    transition: none !important;\n  }\n}\n\n.cm-hover-lift {\n  transition: transform 500ms cubic-bezier(0.22, 1, 0.36, 1),\n              box-shadow 500ms cubic-bezier(0.22, 1, 0.36, 1);\n  will-change: transform;\n}\n.cm-hover-lift:hover {\n  transform: translateY(-6px);\n}\n\n@keyframes cm-shimmer {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n.cm-shimmer {\n  background: linear-gradient(90deg, transparent, rgb(255 255 255 / 0.18), transparent);\n  background-size: 200% 100%;\n  animation: cm-shimmer 3s ease-in-out infinite;\n}\n\n@keyframes cm-glow-breathe {\n  0%, 100% { box-shadow: 0 0 0 0 oklch(var(--primary) / 0); opacity: 0.9; }\n  50%      { box-shadow: 0 0 24px 4px oklch(var(--primary) / 0.22); opacity: 1; }\n}\n.cm-glow-breathe { animation: cm-glow-breathe 3.5s ease-in-out infinite; }\n\n@keyframes cm-tilt-in {\n  from { opacity: 0; transform: perspective(900px) rotateX(8deg) translateY(16px); }\n  to   { opacity: 1; transform: perspective(900px) rotateX(0) translateY(0); }\n}\n.cm-tilt-in { animation: cm-tilt-in 1.1s cubic-bezier(0.22, 1, 0.36, 1) both; }\n\n/* Marketing helpers still used by secondary public pages */\n.cm-landing-hero-bg {\n  background:\n    radial-gradient(ellipse 80% 60% at 85% 20%, oklch(var(--primary) / 0.14) 0%, transparent 55%),\n    radial-gradient(ellipse 50% 40% at 10% 80%, oklch(var(--primary) / 0.06) 0%, transparent 50%),\n    oklch(var(--page));\n}\n\n.cm-landing-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: oklch(var(--primary));\n  background: oklch(var(--primary) / 0.1);\n  border: 1px solid oklch(var(--primary) / 0.4);\n}\n\n.cm-landing-hero-title {\n  font-size: clamp(34px, 5vw, 56px);\n  line-height: 1.1;\n  font-weight: 700;\n  color: oklch(var(--foreground));\n}\n\n.cm-landing-hero-accent {\n  background-image: var(--gradient-text);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.cm-landing-feature-card,\n.cm-landing-product-card {\n  border: 1px solid oklch(var(--border));\n  border-radius: 0.75rem;\n  background-color: oklch(var(--surface));\n  background-image: linear-gradient(to bottom right, oklch(var(--primary) / 0.2), oklch(var(--surface)) 42%, oklch(var(--surface)));\n  box-shadow: var(--shadow-card);\n  transition: border-color 300ms ease, box-shadow 300ms ease, transform 300ms ease;\n}\n.cm-landing-feature-card:hover,\n.cm-landing-product-card:hover {\n  border-color: oklch(var(--primary) / 0.45);\n  box-shadow: var(--shadow-card-hover);\n  transform: translateY(-4px);\n}\n\n.cm-ticker-exchange {\n  background: oklch(var(--surface));\n  border-color: oklch(var(--border));\n}\n\n.cm-landing-section-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: oklch(var(--primary));\n}\n\n.cm-landing-grid-bg {\n  background-image:\n    linear-gradient(oklch(var(--border) / 0.25) 1px, transparent 1px),\n    linear-gradient(90deg, oklch(var(--border) / 0.25) 1px, transparent 1px);\n  background-size: 48px 48px;\n}\n\n.cm-landing-section {\n  padding-top: 3.5rem;\n  padding-bottom: 3.5rem;\n}\n@media (min-width: 1024px) {\n  .cm-landing-section {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n  }\n}\n\n.cm-landing-section-title {\n  font-size: clamp(26px, 4vw, 44px);\n  line-height: 1.15;\n  font-weight: 600;\n  color: oklch(var(--foreground));\n}\n\n.cm-landing-section-alt {\n  background: oklch(var(--page));\n}\n\n.cm-landing-new-badge {\n  font-size: 7px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  padding: 3px 6px;\n  border-radius: 4px;\n  color: oklch(var(--brand-ink));\n  background-image: var(--gradient-brand);\n}\n\n.cm-landing-cta-band {\n  background-image: var(--gradient-brand);\n  color: oklch(var(--brand-ink));\n}\n\n.cm-landing-mesh {\n  background-image:\n    radial-gradient(at 90% 10%, oklch(var(--primary) / 0.14) 0%, transparent 45%),\n    radial-gradient(at 5% 90%, oklch(var(--primary) / 0.08) 0%, transparent 40%);\n}\n\n/* ------------------------------------------------------------------ *\n * PaisaCX utilities                                                   *\n * ------------------------------------------------------------------ */\n.section-band { background-color: oklch(var(--page)); }\n\n.brand-gradient { background-image: var(--gradient-brand); }\n:is(button, a).brand-gradient {\n  transition: filter 0.2s ease, opacity 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;\n}\n:is(button, a).brand-gradient:hover {\n  filter: brightness(1.08) saturate(1.05);\n  box-shadow: var(--shadow-brand);\n}\n:is(button, a).brand-gradient:active {\n  filter: brightness(0.96);\n  transform: scale(0.98);\n}\n\n.brand-text {\n  background-image: var(--gradient-text);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.glass-panel {\n  background-color: oklch(var(--surface) / 0.78);\n  backdrop-filter: blur(18px);\n  border: 1px solid oklch(var(--border));\n  box-shadow: var(--shadow-panel);\n}\n\n.panel-gradient {\n  background-color: oklch(var(--surface));\n  background-image: linear-gradient(to bottom right, oklch(var(--primary) / 0.2), oklch(var(--surface)) 42%, oklch(var(--surface)));\n}\n\n.light .panel-gradient,\n.light .interactive-tile {\n  background-image: linear-gradient(\n    to bottom right,\n    oklch(var(--brand-lime) / 0.22),\n    color-mix(in oklab, oklch(var(--brand-emerald)) 10%, oklch(var(--surface))) 38%,\n    oklch(var(--surface))\n  );\n}\n\n.interactive-tile {\n  position: relative;\n  background-color: oklch(var(--surface));\n  background-image: linear-gradient(to bottom right, oklch(var(--primary) / 0.2), oklch(var(--surface)) 42%, oklch(var(--surface)));\n  box-shadow: var(--shadow-card);\n  transition:\n    transform 0.28s cubic-bezier(0.22, 1, 0.36, 1),\n    border-color 0.28s ease,\n    box-shadow 0.28s ease;\n  will-change: transform;\n}\n.interactive-tile:hover {\n  transform: translateY(-4px);\n  border-color: color-mix(in oklab, oklch(var(--primary)) 45%, oklch(var(--border)));\n  background-image: linear-gradient(\n    to bottom right,\n    oklch(var(--primary) / 0.28),\n    oklch(var(--surface)) 40%,\n    color-mix(in oklab, oklch(var(--surface-2)) 55%, oklch(var(--surface)))\n  );\n  box-shadow: var(--shadow-card-hover);\n}\n.interactive-tile:active {\n  transform: translateY(-1px);\n  transition-duration: 0.12s;\n}\n.interactive-tile .tile-icon {\n  background-image: linear-gradient(145deg, oklch(var(--brand-emerald) / 0.22), oklch(var(--brand-lime) / 0.14));\n  transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1), filter 0.28s ease;\n}\n.interactive-tile:hover .tile-icon {\n  transform: scale(1.08);\n  filter: brightness(1.15);\n}\n\n.interactive-row {\n  transition: background-color 0.2s ease;\n}\n.interactive-row:hover {\n  background-color: oklch(var(--surface-2) / 0.8);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .interactive-tile,\n  .interactive-tile .tile-icon,\n  .interactive-row {\n    transition: none;\n  }\n  .interactive-tile:hover,\n  .interactive-tile:active,\n  .interactive-tile:hover .tile-icon {\n    transform: none;\n  }\n}\n\n.shadow-brand { box-shadow: var(--shadow-brand); }\n\n.hero-grid {\n  background-image:\n    linear-gradient(to right, oklch(var(--border) / 0.25) 1px, transparent 1px),\n    linear-gradient(to bottom, oklch(var(--border) / 0.25) 1px, transparent 1px);\n  background-size: 48px 48px;\n  mask-image: linear-gradient(to bottom, black 0%, black 70%, transparent 100%);\n}\n\n@keyframes hero-rise {\n  from { opacity: 0; transform: translateY(12px); }\n  to { opacity: 1; transform: none; }\n}\n.hero-copy > * { animation: hero-rise 0.6s ease-out both; }\n.hero-copy > *:nth-child(1) { animation-delay: 0.04s; }\n.hero-copy > *:nth-child(2) { animation-delay: 0.12s; }\n.hero-copy > *:nth-child(3) { animation-delay: 0.2s; }\n.hero-copy > *:nth-child(4) { animation-delay: 0.28s; }\n.hero-copy > *:nth-child(5) { animation-delay: 0.36s; }\n\n.hero-video { filter: saturate(0.85) brightness(0.72) contrast(1.1); }\n@media (min-width: 640px) {\n  .hero-video { filter: saturate(0.85) brightness(0.78) contrast(1.1); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .hero-copy > * { animation: none; }\n}\n\n.table-head {\n  background-color: var(--table-head);\n  border-bottom: 1px solid oklch(var(--border));\n  color: oklch(var(--muted-foreground));\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n@keyframes fade-in-soft {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: none; }\n}\n.page-fade { animation: fade-in-soft 0.35s ease-out; }\n\n@keyframes shake-x {\n  0%, 100% { transform: translateX(0); }\n  20% { transform: translateX(-7px); }\n  40% { transform: translateX(6px); }\n  60% { transform: translateX(-4px); }\n  80% { transform: translateX(2px); }\n}\n.animate-shake { animation: shake-x 0.4s ease-in-out; }\n\n@keyframes shimmer-x {\n  from { background-position: -200% 0; }\n  to { background-position: 200% 0; }\n}\n.skeleton {\n  border-radius: 6px;\n  background: linear-gradient(90deg, oklch(var(--surface-2) / 0.8) 25%, oklch(var(--border) / 0.9) 50%, oklch(var(--surface-2) / 0.8) 75%);\n  background-size: 200% 100%;\n  animation: shimmer-x 1.4s linear infinite;\n}\n\n.table-head button {\n  text-transform: inherit;\n  letter-spacing: inherit;\n  font-weight: inherit;\n}\n\n.terminal-row {\n  display: grid;\n  align-items: center;\n  border-bottom: 1px solid oklch(var(--border) / 0.7);\n  transition: background-color 0.15s ease;\n}\n.terminal-row:hover { background-color: oklch(var(--surface-2) / 0.6); }\n\n.chart-grid {\n  background-image:\n    linear-gradient(to right, oklch(var(--border) / 0.35) 1px, transparent 1px),\n    linear-gradient(to bottom, oklch(var(--border) / 0.35) 1px, transparent 1px);\n  background-size: 44px 44px;\n}\n.cta-grid {\n  background-image:\n    linear-gradient(to right, oklch(var(--primary) / 0.08) 1px, transparent 1px),\n    linear-gradient(to bottom, oklch(var(--primary) / 0.08) 1px, transparent 1px);\n  background-size: 36px 36px;\n}\n\n@keyframes flash-up { 0% { background-color: oklch(var(--up) / 0.26); } 100% { background-color: transparent; } }\n@keyframes flash-down { 0% { background-color: oklch(var(--down) / 0.26); } 100% { background-color: transparent; } }\n@keyframes mesh-drift {\n  0% { transform: translate3d(-4%, -2%, 0) scale(1.05); }\n  50% { transform: translate3d(5%, 3%, 0) scale(1.15); }\n  100% { transform: translate3d(-4%, -2%, 0) scale(1.05); }\n}\n@keyframes marquee-x { from { transform: translateX(0); } to { transform: translateX(-50%); } }\n@keyframes float { 0%,100% { transform: translateY(0) } 50% { transform: translateY(-14px) } }\n.flash-up { animation: flash-up 0.9s ease-out; }\n.flash-down { animation: flash-down 0.9s ease-out; }\n.animate-mesh { animation: mesh-drift 18s ease-in-out infinite; }\n.animate-marquee { animation: marquee-x 42s linear infinite; }\n@media (prefers-reduced-motion: reduce) {\n  .motion-safe\\:animate-mesh, .animate-mesh, .animate-marquee { animation: none; }\n}\n\n.ticker-rail { contain: strict; overflow-x: clip; overflow-y: hidden; }\n.ticker-track { width: max-content; max-width: none; }\n\n.feature-art-dark { mix-blend-mode: lighten; }\n.feature-art-light { display: none; }\n.light .feature-art-dark { display: none; }\n.light .feature-art-light { display: block; mix-blend-mode: normal; }\n\n/* Panels lift off the page in both themes */\n:is(.bg-surface, .bg-surface\\/40, .bg-surface\\/50, .bg-card):is(.rounded-lg, .rounded-xl, .rounded-2xl, .rounded-3xl).border {\n  background-color: oklch(var(--surface));\n  box-shadow: var(--shadow-card);\n}\n\n.light .interactive-tile:hover {\n  background-image: linear-gradient(\n    to bottom right,\n    oklch(var(--brand-lime) / 0.3),\n    color-mix(in oklab, oklch(var(--brand-emerald)) 14%, oklch(var(--surface))) 36%,\n    oklch(var(--surface-2))\n  );\n}\n.light :is(input, select, textarea):is(.bg-surface-2, .bg-background) {\n  background-color: oklch(var(--surface));\n  border-color: oklch(var(--input));\n}\n.light :is(input, select, textarea):focus {\n  border-color: oklch(var(--primary));\n  box-shadow: 0 0 0 3px oklch(var(--primary) / 0.18);\n}\n.light :is(button, a).bg-surface-2.border:not(:hover) {\n  background-color: oklch(var(--surface));\n  border-color: oklch(var(--input));\n  box-shadow: 0 1px 2px oklch(0.4 0.06 160 / 0.08);\n}\n.light footer {\n  background-color: color-mix(in oklab, oklch(var(--surface)) 70%, oklch(var(--surface-2)));\n  border-color: oklch(var(--border));\n}\n.light header > div:first-child {\n  background-color: oklch(var(--surface) / 0.88);\n  box-shadow: 0 1px 0 oklch(var(--border)), 0 8px 24px -16px oklch(0.42 0.08 160 / 0.28);\n}\n\n/* Blog — admin rich editor + public article HTML */\n.blog-rich-editor-area:empty::before {\n  content: attr(data-placeholder);\n  color: oklch(var(--dim));\n  pointer-events: none;\n}\n\n.blog-rich-editor-area h2 {\n  font-size: 1.35rem;\n  font-weight: 700;\n  margin: 1rem 0 0.5rem;\n}\n.blog-rich-editor-area h3 {\n  font-size: 1.15rem;\n  font-weight: 700;\n  margin: 0.85rem 0 0.4rem;\n}\n.blog-rich-editor-area blockquote {\n  border-left: 3px solid oklch(var(--primary));\n  padding-left: 1rem;\n  margin: 0.75rem 0;\n  color: oklch(var(--muted-foreground));\n}\n.blog-rich-editor-area ul,\n.blog-rich-editor-area ol {\n  padding-left: 1.5rem;\n  margin: 0.5rem 0;\n}\n.blog-rich-editor-area figure.blog-video-embed,\n.blog-rich-editor-area figure.blog-image-embed {\n  margin: 0.75rem 0;\n  max-width: 100%;\n}\n.blog-rich-editor-area img,\n.blog-rich-editor-area video {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  min-height: 160px;\n  border-radius: 8px;\n  margin: 0;\n  background: #000;\n}\n.blog-rich-editor-area figure.blog-video-embed[data-filename]::after {\n  content: \"Video: \" attr(data-filename);\n  display: block;\n  margin-top: 0.35rem;\n  font-size: 11px;\n  color: oklch(var(--muted-foreground));\n}\n.blog-rich-editor-area a {\n  color: oklch(var(--primary));\n  text-decoration: underline;\n}\n\n.prose-blog,\n.blog-body-html {\n  color: oklch(var(--foreground));\n  line-height: 1.75;\n  font-size: 16px;\n}\n.prose-blog h2,\n.blog-body-html h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 1.5rem 0 0.75rem;\n  color: oklch(var(--foreground));\n}\n.prose-blog h3,\n.blog-body-html h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 1.25rem 0 0.5rem;\n}\n.prose-blog p,\n.blog-body-html p {\n  margin: 0.75rem 0;\n}\n.prose-blog ul,\n.prose-blog ol,\n.blog-body-html ul,\n.blog-body-html ol {\n  margin: 0.75rem 0;\n  padding-left: 1.5rem;\n}\n.prose-blog blockquote,\n.blog-body-html blockquote {\n  border-left: 4px solid oklch(var(--primary));\n  padding-left: 1rem;\n  margin: 1rem 0;\n  color: oklch(var(--muted-foreground));\n  font-style: italic;\n}\n.prose-blog a,\n.blog-body-html a {\n  color: oklch(var(--primary));\n  font-weight: 600;\n  text-decoration: underline;\n}\n.prose-blog img,\n.blog-body-html img,\n.blog-image-embed img {\n  width: 100%;\n  border-radius: 12px;\n  border: 1px solid oklch(var(--border));\n  margin: 1.25rem 0;\n}\n.prose-blog video,\n.blog-body-html video,\n.blog-video-embed video {\n  width: 100%;\n  max-height: 480px;\n  border-radius: 12px;\n  border: 1px solid oklch(var(--border));\n  background: #000;\n  margin: 1.25rem 0;\n}\n.prose-blog figure,\n.blog-body-html figure {\n  margin: 1.25rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
